/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  AccessCheckResult,
  AdminInit,
  AuthProviderConfigCreate,
  AuthProviderConfigUpdate,
  AuthProviderResponse,
  AuthProviderType,
  BodyLoginForAccessTokenApiAuthTokenPost,
  BodyParsePfxApiDocumentSourcesAdminParsePfxPost,
  BodyUpdateDocumentFileApiDocumentsDocumentIdFilePut,
  BodyUpdateDocumentPermissionsApiDocumentsDocumentIdPermissionsPut,
  BodyUploadDocumentApiDocumentsUploadPost,
  BulkDeleteConversationsRequest,
  BulkDeleteConversationsResponse,
  BulkDocumentDeleteRequest,
  BulkDocumentPermissionsRequest,
  BulkDocumentsResponse,
  BulkExportConversationsRequest,
  CanShareResponse,
  ChatConfigRequest,
  ChatConfigResponse,
  ChatConfigTest,
  ChatProviderResponse,
  ChatRequest,
  ConnectionSyncStatus,
  ConversationDetails,
  ConversationSummary,
  CreateConversationRequest,
  Document,
  DocumentCreate,
  DocumentListResponse,
  DocumentSortBy,
  DocumentSourceProviderConfigRequest,
  DocumentSourceProviderConfigResponse,
  DocumentSourceSyncStatsResponse,
  DocumentSourceUserConnectionRequest,
  DocumentSourceUserConnectionResponse,
  EligibleApproversResponse,
  EmailVerification,
  EmbeddingConfig,
  EmbeddingProviderResponse,
  EmbeddingTestResponse,
  ErrorResponse,
  FAQDocumentCreate,
  FAQDocumentResponse,
  FAQDocumentUpdate,
  FAQListResponse,
  FAQPendingCountResponse,
  FAQSearchResponse,
  FAQSortBy,
  FAQStatsResponse,
  FAQStatus,
  FAQStatusUpdate,
  FolderSync,
  FolderSyncCreate,
  FolderSyncUpdate,
  Group,
  GroupCreate,
  GroupListResponse,
  GroupMemberListResponse,
  GroupMemberUpdate,
  GroupRequest,
  GroupRequestApproval,
  GroupRequestCreate,
  GroupRequestListResponse,
  GroupStatus,
  GroupType,
  GroupUpdate,
  GroupVisibility,
  HTTPValidationError,
  McpAuditListResponse,
  McpServerConfigCreate,
  McpServerConfigResponse,
  McpServerConfigUpdate,
  MemberRole,
  MemberStatus,
  MessageFeedbackRequest,
  MessageFeedbackResponse,
  OperationResponse,
  OrganizationUpdate,
  PaginatedResponseConversationSummary,
  PaginatedResponseMessageResponse,
  ParsedPfxResponse,
  PasswordChangeRequest,
  PasswordReset,
  PasswordResetConfirm,
  PrimaryProviderResponse,
  ProviderConfigDeletionResponse,
  ProviderConfigSyncStatus,
  QdrantCollectionResponse,
  RecipientSearchResponse,
  RetrievalKillSwitchRequest,
  SMTPConfigRequest,
  SMTPConfigResponse,
  SMTPConfigurationResponse,
  SearchRequest,
  SearchResponse,
  SearchResultsResponse,
  SetPrimaryProviderRequest,
  SettingsUpdate,
  SharedFolderImportRequest,
  SharedFolderValidateRequest,
  StatusResponse,
  SystemCleanupResponse,
  SystemStatusResponse,
  TestEmailRequest,
  TextExtractionRequest,
  TextExtractionResponse,
  UnlinkIdentityResponse,
  UpdateConversationRequest,
  UploadCapabilitiesResponse,
  User,
  UserChatPreference,
  UserCreate,
  UserListResponse,
  UserRegister,
  UserUpdate,
  ValidateFolderUrlRequest,
  ValidateFolderUrlResponse,
  WhoAmIResponse,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Api<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * @description Health check endpoint.
   *
   * @tags Public
   * @name HealthCheck
   * @summary Health Check
   * @request GET:/api/health
   * @secure
   */
  healthCheck = (params: RequestParams = {}) =>
    this.request<any, any>({
      path: `/api/health`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Get system version information (read once at startup; no per-request I/O).
   *
   * @tags Public
   * @name GetVersion
   * @summary Get Version
   * @request GET:/api/version
   * @secure
   */
  getVersion = (params: RequestParams = {}) =>
    this.request<any, any>({
      path: `/api/version`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Check if at least one admin user exists in the system.
   *
   * @tags Public
   * @name AdminExists
   * @summary Admin Exists
   * @request GET:/api/admin-exists
   * @secure
   */
  adminExists = (params: RequestParams = {}) =>
    this.request<any, any>({
      path: `/api/admin-exists`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Initialize the system with an admin user. This endpoint can only be used if no users exist in the system.
   *
   * @tags Public
   * @name InitializeSystem
   * @summary Initialize System
   * @request POST:/api/init
   * @secure
   */
  initializeSystem = (data: AdminInit, params: RequestParams = {}) =>
    this.request<StatusResponse, HTTPValidationError>({
      path: `/api/init`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Get list of available authentication providers for login. This is a public endpoint that doesn't require authentication.
   *
   * @tags Public
   * @name GetAvailableAuthProviders
   * @summary Get Available Auth Providers
   * @request GET:/api/auth-providers
   * @secure
   */
  getAvailableAuthProviders = (params: RequestParams = {}) =>
    this.request<any, any>({
      path: `/api/auth-providers`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Get public Entra configuration for frontend MSAL initialization. Returns only non-sensitive config like tenant_id and client_id.
   *
   * @tags Public
   * @name GetEntraConfig
   * @summary Get Entra Config
   * @request GET:/api/auth/entra/config
   * @secure
   */
  getEntraConfig = (params: RequestParams = {}) =>
    this.request<any, any>({
      path: `/api/auth/entra/config`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Endpoint to receive Content Security Policy (CSP) violation reports. This endpoint is called by the browser when CSP violations occur. It logs the violations for security monitoring and investigation. **EXEMPT FROM CSRF:** Browser-generated reports, not user requests. CSP violations can indicate: - XSS attack attempts - Malicious browser extensions - Misconfigured CSP policies - Third-party script issues Args: request: FastAPI Request object containing the CSP violation report Returns: Response: 204 No Content (standard for CSP report endpoints) Security Notes: - This endpoint is exempt from CSRF protection (browser reports) - Does not require authentication (browser reports) - Logs violations for security monitoring - Always returns 204 No Content (per CSP spec)
   *
   * @tags Security
   * @name CspViolationReport
   * @summary Csp Violation Report
   * @request POST:/api/csp-violation-report
   * @secure
   */
  cspViolationReport = (params: RequestParams = {}) =>
    this.request<any, any>({
      path: `/api/csp-violation-report`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Get recommended security headers configuration. This endpoint provides information about security headers that should be configured in the web server or reverse proxy. Returns: Dict: Recommended security headers and their values
   *
   * @tags Security
   * @name GetSecurityHeaders
   * @summary Get Security Headers
   * @request GET:/api/security-headers
   * @secure
   */
  getSecurityHeaders = (params: RequestParams = {}) =>
    this.request<any, any>({
      path: `/api/security-headers`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description OAuth2 compatible token login with cookie-based authentication. **Changes:** - Sets HttpOnly cookies - Returns minimal response (frontend calls /auth/who-am-i for user data) Args: response: FastAPI Response object form_data: OAuth2 password request form Returns: Dict: Status message only (no tokens, no user data)
   *
   * @tags Authentication
   * @name LoginForAccessToken
   * @summary Login For Access Token
   * @request POST:/api/auth/token
   * @secure
   */
  loginForAccessToken = (
    data: BodyLoginForAccessTokenApiAuthTokenPost,
    params: RequestParams = {},
  ) =>
    this.request<StatusResponse, HTTPValidationError>({
      path: `/api/auth/token`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.UrlEncoded,
      format: "json",
      ...params,
    });
  /**
   * @description Refresh access token using refresh token from cookie. **Changes:** - Reads refresh_token from cookie (not request body) - Updates cookies with new tokens Args: response: FastAPI Response object refresh_token: Refresh token from cookie Returns: Dict: Status message only (no tokens, no user data)
   *
   * @tags Authentication
   * @name RefreshAccessToken
   * @summary Refresh Access Token
   * @request POST:/api/auth/refresh
   * @secure
   */
  refreshAccessToken = (params: RequestParams = {}) =>
    this.request<StatusResponse, HTTPValidationError>({
      path: `/api/auth/refresh`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Logout user by clearing authentication cookies and CSRF token. **Security:** Clears all authentication-related cookies including CSRF token. Args: response: FastAPI Response object user: The authenticated user, if the access-token cookie is still valid; ``None`` otherwise (e.g. already expired). Logout clears cookies either way. Returns: Dict: Status message
   *
   * @tags Authentication
   * @name Logout
   * @summary Logout
   * @request POST:/api/auth/logout
   * @secure
   */
  logout = (params: RequestParams = {}) =>
    this.request<StatusResponse, HTTPValidationError>({
      path: `/api/auth/logout`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Initiate Entra ID (Microsoft Azure AD) login flow. Redirects user to Microsoft login page.
   *
   * @tags Authentication
   * @name EntraLoginRedirect
   * @summary Entra Login Redirect
   * @request GET:/api/auth/entra/login
   * @secure
   */
  entraLoginRedirect = (params: RequestParams = {}) =>
    this.request<any, any>({
      path: `/api/auth/entra/login`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Exchange MSAL access token for backend JWT tokens. Used when frontend handles OAuth2 flow with MSAL. Sets CSRF token cookie on successful authentication.
   *
   * @tags Authentication
   * @name EntraTokenExchange
   * @summary Entra Token Exchange
   * @request POST:/api/auth/entra/token-exchange
   * @secure
   */
  entraTokenExchange = (
    data: Record<string, any>,
    params: RequestParams = {},
  ) =>
    this.request<any, HTTPValidationError>({
      path: `/api/auth/entra/token-exchange`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Handle Entra ID OAuth callback and authenticate user. Sets authentication cookies and CSRF token on successful authentication.
   *
   * @tags Authentication
   * @name EntraLoginCallback
   * @summary Entra Login Callback
   * @request GET:/api/auth/entra/callback
   * @secure
   */
  entraLoginCallback = (
    query?: {
      /** Code */
      code?: string;
      /** State */
      state?: string;
      /** Error */
      error?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<any, HTTPValidationError>({
      path: `/api/auth/entra/callback`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Register a new user. Args: user_data: User registration data Returns: Dict[str, Any]: Registration status
   *
   * @tags Authentication
   * @name RegisterUser
   * @summary Register User
   * @request POST:/api/auth/register
   * @secure
   */
  registerUser = (data: UserRegister, params: RequestParams = {}) =>
    this.request<any, HTTPValidationError>({
      path: `/api/auth/register`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Verify a user's email address using a token. Args: verification_data: Email verification data Returns: Dict[str, Any]: Verification status
   *
   * @tags Authentication
   * @name VerifyEmail
   * @summary Verify Email
   * @request POST:/api/auth/verify-email
   * @secure
   */
  verifyEmail = (data: EmailVerification, params: RequestParams = {}) =>
    this.request<any, HTTPValidationError>({
      path: `/api/auth/verify-email`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Resend verification email. Args: email_data: Email data containing the user's email Returns: Dict[str, Any]: Status message
   *
   * @tags Authentication
   * @name ResendVerificationEmail
   * @summary Resend Verification Email
   * @request POST:/api/auth/resend-verification
   * @secure
   */
  resendVerificationEmail = (
    data: Record<string, string>,
    params: RequestParams = {},
  ) =>
    this.request<StatusResponse, HTTPValidationError>({
      path: `/api/auth/resend-verification`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Request a password reset. Args: reset_data: Password reset request data Returns: Dict[str, Any]: Status message
   *
   * @tags Authentication
   * @name RequestPasswordReset
   * @summary Request Password Reset
   * @request POST:/api/auth/request-password-reset
   * @secure
   */
  requestPasswordReset = (data: PasswordReset, params: RequestParams = {}) =>
    this.request<StatusResponse, HTTPValidationError>({
      path: `/api/auth/request-password-reset`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Reset password with token. Args: reset_data: Password reset confirmation data Returns: Dict[str, Any]: Status message
   *
   * @tags Authentication
   * @name ResetPassword
   * @summary Reset Password
   * @request POST:/api/auth/reset-password
   * @secure
   */
  resetPassword = (data: PasswordResetConfirm, params: RequestParams = {}) =>
    this.request<StatusResponse, HTTPValidationError>({
      path: `/api/auth/reset-password`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Get all authentication provider configurations.
   *
   * @tags Auth Providers
   * @name GetAllAuthProviders
   * @summary Get All Auth Providers
   * @request GET:/api/auth-providers/
   * @secure
   */
  getAllAuthProviders = (params: RequestParams = {}) =>
    this.request<AuthProviderResponse[], HTTPValidationError>({
      path: `/api/auth-providers/`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Create a new authentication provider configuration.
   *
   * @tags Auth Providers
   * @name CreateAuthProvider
   * @summary Create Auth Provider
   * @request POST:/api/auth-providers/
   * @secure
   */
  createAuthProvider = (
    data: AuthProviderConfigCreate,
    params: RequestParams = {},
  ) =>
    this.request<AuthProviderResponse, HTTPValidationError>({
      path: `/api/auth-providers/`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Get configuration for a specific authentication provider.
   *
   * @tags Auth Providers
   * @name GetAuthProvider
   * @summary Get Auth Provider
   * @request GET:/api/auth-providers/{provider_type}
   * @secure
   */
  getAuthProvider = (
    providerType: AuthProviderType,
    params: RequestParams = {},
  ) =>
    this.request<AuthProviderResponse, ErrorResponse | HTTPValidationError>({
      path: `/api/auth-providers/${providerType}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Update an existing authentication provider configuration.
   *
   * @tags Auth Providers
   * @name UpdateAuthProvider
   * @summary Update Auth Provider
   * @request PUT:/api/auth-providers/{provider_type}
   * @secure
   */
  updateAuthProvider = (
    providerType: AuthProviderType,
    data: AuthProviderConfigUpdate,
    params: RequestParams = {},
  ) =>
    this.request<AuthProviderResponse, ErrorResponse | HTTPValidationError>({
      path: `/api/auth-providers/${providerType}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Delete an authentication provider configuration.
   *
   * @tags Auth Providers
   * @name DeleteAuthProvider
   * @summary Delete Auth Provider
   * @request DELETE:/api/auth-providers/{provider_type}
   * @secure
   */
  deleteAuthProvider = (
    providerType: AuthProviderType,
    params: RequestParams = {},
  ) =>
    this.request<OperationResponse, ErrorResponse | HTTPValidationError>({
      path: `/api/auth-providers/${providerType}`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Set the primary authentication provider for the system.
   *
   * @tags Auth Providers
   * @name SetPrimaryAuthProvider
   * @summary Set Primary Auth Provider
   * @request PUT:/api/auth-providers/primary
   * @secure
   */
  setPrimaryAuthProvider = (
    data: SetPrimaryProviderRequest,
    params: RequestParams = {},
  ) =>
    this.request<PrimaryProviderResponse, HTTPValidationError>({
      path: `/api/auth-providers/primary`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Create a new user (moderator or admin only). Args: user: User creation data current_user: Authenticated user with moderator privileges user_service: Injected user-management service Returns: User: Created user object
   *
   * @tags Users
   * @name CreateUser
   * @summary Create User
   * @request POST:/api/users/
   * @secure
   */
  createUser = (data: UserCreate, params: RequestParams = {}) =>
    this.request<User, ErrorResponse | HTTPValidationError>({
      path: `/api/users/`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Get a paginated list of users with optional search (all authenticated users). Note: Previously required moderator privileges, now accessible to all authenticated users. Field filtering based on role: - ADMIN: Returns all user fields (id, username, email, full_name, role, active, created_at, etc.) - MODERATOR: Returns only id, username, email, full_name - STANDARD: Returns only id, username, email, full_name Args: skip: Number of users to skip (for pagination) limit: Maximum number of users to return search: Optional search query (searches username, email, full_name) current_user: Authenticated user Returns: Dict with 'users' array (User objects for admin, UserBasicInfo for non-admin) and 'total' count
   *
   * @tags Users
   * @name GetUsers
   * @summary Get Users
   * @request GET:/api/users/
   * @secure
   */
  getUsers = (
    query?: {
      /**
       * Skip
       * @default 0
       */
      skip?: number;
      /**
       * Limit
       * @default 20
       */
      limit?: number;
      /** Search */
      search?: string | null;
    },
    params: RequestParams = {},
  ) =>
    this.request<UserListResponse, ErrorResponse | HTTPValidationError>({
      path: `/api/users/`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Search users for autocomplete (returns basic info only). Args: q: Search query (searches username, email, full_name) limit: Maximum number of results current_user: Authenticated user Returns: List of basic user info for autocomplete
   *
   * @tags Users
   * @name SearchUsers
   * @summary Search Users
   * @request GET:/api/users/search
   * @secure
   */
  searchUsers = (
    query: {
      /**
       * Q
       * Search query
       * @minLength 1
       */
      q: string;
      /**
       * Limit
       * Maximum number of results
       * @min 1
       * @max 50
       * @default 10
       */
      limit?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<SearchResultsResponse, ErrorResponse | HTTPValidationError>({
      path: `/api/users/search`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Get all active users for sharing purposes. This endpoint is accessible to all authenticated users and returns basic user information needed for sharing documents. Args: limit: Maximum number of users current_user: Authenticated user Returns: Dictionary with results list and total count
   *
   * @tags Users
   * @name GetUsersForSharing
   * @summary Get Users For Sharing
   * @request GET:/api/users/for-sharing
   * @secure
   */
  getUsersForSharing = (
    query?: {
      /**
       * Limit
       * Maximum number of users
       * @min 1
       * @max 200
       * @default 100
       */
      limit?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<SearchResultsResponse, ErrorResponse | HTTPValidationError>({
      path: `/api/users/for-sharing`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Get user identity information with role-based permissions from access token. Returns user information including: - Basic identity (user_id, username, email, full_name, role) - Permissions for all features based on role hierarchy Permissions are calculated from the PermissionSet class which defines hierarchical role-based access control: - STANDARD: dashboard, chat, documents, settings, my_groups - MODERATOR: + users, groups - ADMIN: + chat_config, embedding_config, text_extraction_config, document_sources, smtp_config Args: current_user: Authenticated user (extracted from JWT token) Returns: WhoAmIResponse: User identity with complete permissions mapping
   *
   * @tags Users
   * @name WhoAmI
   * @summary Who Am I
   * @request GET:/api/users/who-am-i
   * @secure
   */
  whoAmI = (params: RequestParams = {}) =>
    this.request<WhoAmIResponse, ErrorResponse | HTTPValidationError>({
      path: `/api/users/who-am-i`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Get a user by username (admin only). Args: username: Username to look up current_user: Authenticated user with admin privileges Returns: User: User object
   *
   * @tags Users
   * @name GetUser
   * @summary Get User
   * @request GET:/api/users/{username}
   * @secure
   */
  getUser = (username: string, params: RequestParams = {}) =>
    this.request<User, ErrorResponse | HTTPValidationError>({
      path: `/api/users/${username}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Update a user. Args: username: Username of the user to update user_update: Updated user data current_user: Authenticated user Returns: User: Updated user object
   *
   * @tags Users
   * @name UpdateUser
   * @summary Update User
   * @request PUT:/api/users/{username}
   * @secure
   */
  updateUser = (
    username: string,
    data: UserUpdate,
    params: RequestParams = {},
  ) =>
    this.request<User, ErrorResponse | HTTPValidationError>({
      path: `/api/users/${username}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Soft delete a user (admin only). User enters 7-day grace period. Args: username: Username of the user to delete current_user: Authenticated user with admin privileges Returns: Dict[str, Any]: Status message
   *
   * @tags Users
   * @name DeleteUser
   * @summary Delete User
   * @request DELETE:/api/users/{username}
   * @secure
   */
  deleteUser = (username: string, params: RequestParams = {}) =>
    this.request<StatusResponse, ErrorResponse | HTTPValidationError>({
      path: `/api/users/${username}`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Change own password with current password verification. This endpoint requires the user to provide their current password for security. This prevents password changes if an attacker gains temporary access to an authenticated session. Args: password_data: Current and new password current_user: Authenticated user Returns: Success message Raises: HTTPException 401: If current password is incorrect HTTPException 400: If new password doesn't meet requirements
   *
   * @tags Users
   * @name ChangeOwnPassword
   * @summary Change Own Password
   * @request POST:/api/users/me/change-password
   * @secure
   */
  changeOwnPassword = (
    data: PasswordChangeRequest,
    params: RequestParams = {},
  ) =>
    this.request<StatusResponse, ErrorResponse | HTTPValidationError>({
      path: `/api/users/me/change-password`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Request deletion of own account. User enters 7-day grace period. Args: current_user: Authenticated user Returns: Dict[str, Any]: Status message
   *
   * @tags Users
   * @name RequestOwnDeletion
   * @summary Request Own Deletion
   * @request POST:/api/users/me/request-deletion
   * @secure
   */
  requestOwnDeletion = (params: RequestParams = {}) =>
    this.request<StatusResponse, ErrorResponse | HTTPValidationError>({
      path: `/api/users/me/request-deletion`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Cancel deletion request for a user. Users can cancel their own deletion. Admins can cancel any deletion. Args: username: Username of the user current_user: Authenticated user Returns: Dict[str, Any]: Status message
   *
   * @tags Users
   * @name CancelDeletion
   * @summary Cancel Deletion
   * @request POST:/api/users/{username}/cancel-deletion
   * @secure
   */
  cancelDeletion = (username: string, params: RequestParams = {}) =>
    this.request<StatusResponse, ErrorResponse | HTTPValidationError>({
      path: `/api/users/${username}/cancel-deletion`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Create a new group creation request. Only STANDARD users can submit group creation requests. ADMIN and MODERATOR users can create groups directly via POST /api/groups. Requires at least one approver (ADMIN or MODERATOR). Args: request_data: Group creation request data current_user: Authenticated standard user Returns: Created GroupRequest object Raises: HTTPException: 400 if validation fails, 403 if not standard user
   *
   * @tags Group Requests
   * @name CreateGroupRequest
   * @summary Create Group Request
   * @request POST:/api/groups/requests
   * @secure
   */
  createGroupRequest = (data: GroupRequestCreate, params: RequestParams = {}) =>
    this.request<GroupRequest, ErrorResponse | HTTPValidationError>({
      path: `/api/groups/requests`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Get list of eligible approvers (ADMIN and MODERATOR users). Any authenticated user can see the list of approvers. Returns: List of approver user objects with id, username, email, role
   *
   * @tags Group Requests
   * @name GetEligibleApprovers
   * @summary Get Eligible Approvers
   * @request GET:/api/groups/requests/eligible-approvers
   * @secure
   */
  getEligibleApprovers = (params: RequestParams = {}) =>
    this.request<
      EligibleApproversResponse,
      ErrorResponse | HTTPValidationError
    >({
      path: `/api/groups/requests/eligible-approvers`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Get current user's own group creation requests with pagination (Requirement 9). Args: status_filter: Optional status filter (pending, approved, rejected, cancelled) page: Page number (1-indexed, default: 1) page_size: Items per page (default: 20, max: 100) current_user: Authenticated user Returns: Paginated list of user's GroupRequest objects
   *
   * @tags Group Requests
   * @name GetMyRequests
   * @summary Get My Requests
   * @request GET:/api/groups/requests/my-requests
   * @secure
   */
  getMyRequests = (
    query?: {
      /** Status Filter */
      status_filter?: string | null;
      /**
       * Page
       * Page number (1-indexed)
       * @min 1
       * @default 1
       */
      page?: number;
      /**
       * Page Size
       * Items per page
       * @min 1
       * @max 100
       * @default 20
       */
      page_size?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<GroupRequestListResponse, ErrorResponse | HTTPValidationError>(
      {
        path: `/api/groups/requests/my-requests`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      },
    );
  /**
   * @description Get pending group creation requests for Admin/Moderator dashboard (Requirement 9). Only ADMIN and MODERATOR users can access this endpoint. Returns requests assigned to current approver, ordered by requested_at (oldest first for FIFO). Args: page: Page number (1-indexed, default: 1) page_size: Items per page (default: 20, max: 100) current_user: Authenticated approver user Returns: Paginated list of pending GroupRequest objects with summary statistics
   *
   * @tags Group Requests
   * @name GetPendingRequests
   * @summary Get Pending Requests
   * @request GET:/api/groups/requests/pending
   * @secure
   */
  getPendingRequests = (
    query?: {
      /**
       * Page
       * Page number (1-indexed)
       * @min 1
       * @default 1
       */
      page?: number;
      /**
       * Page Size
       * Items per page
       * @min 1
       * @max 100
       * @default 20
       */
      page_size?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<GroupRequestListResponse, ErrorResponse | HTTPValidationError>(
      {
        path: `/api/groups/requests/pending`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      },
    );
  /**
   * @description Get details of a specific group creation request. Users can view: - Their own requests - Requests where they are an approver (if ADMIN/MODERATOR) Args: request_id: Request ID current_user: Authenticated user Returns: GroupRequest object Raises: HTTPException: 404 if not found, 403 if not authorized
   *
   * @tags Group Requests
   * @name GetRequestDetails
   * @summary Get Request Details
   * @request GET:/api/groups/requests/{request_id}
   * @secure
   */
  getRequestDetails = (requestId: string, params: RequestParams = {}) =>
    this.request<GroupRequest, ErrorResponse | HTTPValidationError>({
      path: `/api/groups/requests/${requestId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Cancel a pending group creation request. Users can only cancel their own pending requests. Args: request_id: Request ID current_user: Authenticated user Returns: Success message Raises: HTTPException: 400 if not pending, 403 if not own request, 404 if not found
   *
   * @tags Group Requests
   * @name CancelGroupRequest
   * @summary Cancel Group Request
   * @request DELETE:/api/groups/requests/{request_id}
   * @secure
   */
  cancelGroupRequest = (requestId: string, params: RequestParams = {}) =>
    this.request<any, ErrorResponse | HTTPValidationError>({
      path: `/api/groups/requests/${requestId}`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Approve a group creation request. Creates the group automatically with: - Requester as group OWNER and first group admin - initial_admin_id (from request) as second group admin - Both admins get ADMIN group membership role IMPORTANT: - Approvers must have system ADMIN or MODERATOR role (to approve requests) - Group admins can be ANY user (group-level role, not system role) - Approver must be in the request's approver list Args: request_id: Request ID approval: Approval data with optional admin notes current_user: Authenticated approver user Returns: Dict with group and request information Raises: HTTPException: 400 if already processed, 403 if not authorized, 404 if not found
   *
   * @tags Group Requests
   * @name ApproveGroupRequest
   * @summary Approve Group Request
   * @request POST:/api/groups/requests/{request_id}/approve
   * @secure
   */
  approveGroupRequest = (
    requestId: string,
    data: GroupRequestApproval,
    params: RequestParams = {},
  ) =>
    this.request<any, ErrorResponse | HTTPValidationError>({
      path: `/api/groups/requests/${requestId}/approve`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Reject a group creation request. Only ADMIN and MODERATOR users can reject requests. Approver must be in the request's approver list. Rejection reason is required. Args: request_id: Request ID rejection: Rejection data with rejection_reason and optional admin_notes current_user: Authenticated approver user Returns: Success message Raises: HTTPException: 400 if validation fails or already processed, 403 if not authorized, 404 if not found
   *
   * @tags Group Requests
   * @name RejectGroupRequest
   * @summary Reject Group Request
   * @request POST:/api/groups/requests/{request_id}/reject
   * @secure
   */
  rejectGroupRequest = (
    requestId: string,
    data: GroupRequestApproval,
    params: RequestParams = {},
  ) =>
    this.request<any, ErrorResponse | HTTPValidationError>({
      path: `/api/groups/requests/${requestId}/reject`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Mark request as being viewed (UI hint only, not enforced). This provides a user experience hint showing other admins that someone is currently viewing the request. However, the actual approval/rejection uses optimistic locking, so this viewing status doesn't prevent concurrent processing. Args: request_id: Request ID current_user: Authenticated user Returns: Success status and message (includes current viewer username if someone else viewing) Raises: HTTPException: 400 if invalid request ID
   *
   * @tags Group Requests
   * @name MarkRequestViewing
   * @summary Mark Request Viewing
   * @request POST:/api/groups/requests/{request_id}/mark-viewing
   * @secure
   */
  markRequestViewing = (requestId: string, params: RequestParams = {}) =>
    this.request<any, ErrorResponse | HTTPValidationError>({
      path: `/api/groups/requests/${requestId}/mark-viewing`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Clear viewing status on a request. Called when user closes the request detail modal or navigates away. Args: request_id: Request ID current_user: Authenticated user Returns: Success message Raises: HTTPException: 400 if invalid request ID
   *
   * @tags Group Requests
   * @name ClearRequestViewing
   * @summary Clear Request Viewing
   * @request POST:/api/groups/requests/{request_id}/clear-viewing
   * @secure
   */
  clearRequestViewing = (requestId: string, params: RequestParams = {}) =>
    this.request<any, ErrorResponse | HTTPValidationError>({
      path: `/api/groups/requests/${requestId}/clear-viewing`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Get groups where owner was deleted and awaiting new owner selection (Requirement 9). Only ADMIN and MODERATOR users can access this endpoint. Returns groups with: - Group details - Temporary owner information - List of eligible Group Admins (GAs) for selection - Member count and status Args: page: Page number (1-indexed, default: 1) page_size: Items per page (default: 20, max: 100) current_user: Authenticated admin/moderator user Returns: Paginated list of groups awaiting owner selection
   *
   * @tags Group Requests
   * @name GetGroupsAwaitingOwnerSelection
   * @summary Get Groups Awaiting Owner Selection
   * @request GET:/api/groups/owner-deletions
   * @secure
   */
  getGroupsAwaitingOwnerSelection = (
    query?: {
      /**
       * Page
       * Page number (1-indexed)
       * @min 1
       * @default 1
       */
      page?: number;
      /**
       * Page Size
       * Items per page
       * @min 1
       * @max 100
       * @default 20
       */
      page_size?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<any, ErrorResponse | HTTPValidationError>({
      path: `/api/groups/owner-deletions`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Finalize new owner selection after owner deletion (Requirement 9). Only ADMIN and MODERATOR users can finalize owner selection. The new owner must be an existing Group Admin (GA) in the group. This endpoint: - Promotes the selected GA to OWNER role - Removes the temporary owner - Clears awaiting_owner_selection flag Args: group_id: Group ID new_owner_id: User ID of the new owner (must be existing GA) current_user: Authenticated admin/moderator user Returns: Success message with new owner details Raises: HTTPException: 400 if validation fails, 403 if not authorized, 404 if not found
   *
   * @tags Group Requests
   * @name FinalizeNewGroupOwner
   * @summary Finalize New Group Owner
   * @request POST:/api/groups/{group_id}/finalize-owner
   * @secure
   */
  finalizeNewGroupOwner = (
    groupId: string,
    query: {
      /** New Owner Id */
      new_owner_id: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<any, ErrorResponse | HTTPValidationError>({
      path: `/api/groups/${groupId}/finalize-owner`,
      method: "POST",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Search groups for autocomplete (returns basic info only). Args: q: Search query (searches displayName, name, description) limit: Maximum number of results current_user: Authenticated user group_manager: GroupManager instance Returns: List of basic group info for autocomplete
   *
   * @tags Groups
   * @name SearchGroups
   * @summary Search Groups
   * @request GET:/api/groups/search
   * @secure
   */
  searchGroups = (
    query: {
      /**
       * Q
       * Search query
       * @minLength 1
       */
      q: string;
      /**
       * Limit
       * Maximum number of results
       * @min 1
       * @max 50
       * @default 10
       */
      limit?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<SearchResultsResponse, ErrorResponse | HTTPValidationError>({
      path: `/api/groups/search`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Create a new group (with permission check).
   *
   * @tags Groups
   * @name CreateGroup
   * @summary Create Group
   * @request POST:/api/groups/
   * @secure
   */
  createGroup = (data: GroupCreate, params: RequestParams = {}) =>
    this.request<Group, ErrorResponse | HTTPValidationError>({
      path: `/api/groups/`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description List accessible groups with filters and pagination. Supports flexible filtering by query, type, status, visibility, and tags. Automatically initializes default groups if database is empty.
   *
   * @tags Groups
   * @name ListGroups
   * @summary List Groups
   * @request GET:/api/groups/
   * @secure
   */
  listGroups = (
    query?: {
      /**
       * Query
       * Search query
       */
      query?: string | null;
      /**
       * Type
       * Filter by group type
       */
      type?: GroupType | null;
      /**
       * Status
       * Filter by status
       */
      status?: GroupStatus | null;
      /**
       * Visibility
       * Filter by visibility
       */
      visibility?: GroupVisibility | null;
      /**
       * Member Of
       * Only groups user is member of
       */
      member_of?: boolean | null;
      /**
       * Admin Of
       * Only groups user administrates
       */
      admin_of?: boolean | null;
      /**
       * Tags
       * Comma-separated tags
       */
      tags?: string | null;
      /**
       * Page
       * Page number (1-indexed)
       * @min 1
       * @default 1
       */
      page?: number;
      /**
       * Page Size
       * Items per page
       * @min 1
       * @max 100
       * @default 50
       */
      page_size?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<GroupListResponse, ErrorResponse | HTTPValidationError>({
      path: `/api/groups/`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Get all groups where current user is a member with pagination. Supports filtering by membership status (active, pending, suspended, expired).
   *
   * @tags Groups
   * @name GetMyGroups
   * @summary Get My Groups
   * @request GET:/api/groups/my-groups
   * @secure
   */
  getMyGroups = (
    query?: {
      /**
       * Status
       * Filter by membership status
       */
      status?: MemberStatus | null;
      /**
       * Page
       * Page number (1-indexed)
       * @min 1
       * @default 1
       */
      page?: number;
      /**
       * Page Size
       * Items per page
       * @min 1
       * @max 100
       * @default 50
       */
      page_size?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<GroupListResponse, ErrorResponse | HTTPValidationError>({
      path: `/api/groups/my-groups`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Get group details.
   *
   * @tags Groups
   * @name GetGroup
   * @summary Get Group
   * @request GET:/api/groups/{group_id}
   * @secure
   */
  getGroup = (groupId: string, params: RequestParams = {}) =>
    this.request<Group, ErrorResponse | HTTPValidationError>({
      path: `/api/groups/${groupId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Update group details (Admins only).
   *
   * @tags Groups
   * @name UpdateGroup
   * @summary Update Group
   * @request PUT:/api/groups/{group_id}
   * @secure
   */
  updateGroup = (
    groupId: string,
    data: GroupUpdate,
    params: RequestParams = {},
  ) =>
    this.request<Group, ErrorResponse | HTTPValidationError>({
      path: `/api/groups/${groupId}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Delete group (Owner only).
   *
   * @tags Groups
   * @name DeleteGroup
   * @summary Delete Group
   * @request DELETE:/api/groups/{group_id}
   * @secure
   */
  deleteGroup = (groupId: string, params: RequestParams = {}) =>
    this.request<OperationResponse, ErrorResponse | HTTPValidationError>({
      path: `/api/groups/${groupId}`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Request to join a group.
   *
   * @tags Groups
   * @name RequestToJoinGroup
   * @summary Request To Join Group
   * @request POST:/api/groups/{group_id}/join
   * @secure
   */
  requestToJoinGroup = (
    groupId: string,
    query?: {
      /** Reason */
      reason?: string | null;
    },
    params: RequestParams = {},
  ) =>
    this.request<OperationResponse, ErrorResponse | HTTPValidationError>({
      path: `/api/groups/${groupId}/join`,
      method: "POST",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description List group members with enhanced user information and pagination. Returns detailed member information including username, full name, email, role, status, and permissions. Only accessible to group members and admins.
   *
   * @tags Groups
   * @name GetGroupMembers
   * @summary Get Group Members
   * @request GET:/api/groups/{group_id}/members
   * @secure
   */
  getGroupMembers = (
    groupId: string,
    query?: {
      /**
       * Status
       * Filter by status
       */
      status?: MemberStatus | null;
      /**
       * Role
       * Filter by role
       */
      role?: MemberRole | null;
      /**
       * Page
       * Page number (1-indexed)
       * @min 1
       * @default 1
       */
      page?: number;
      /**
       * Page Size
       * Items per page
       * @min 1
       * @max 100
       * @default 50
       */
      page_size?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<GroupMemberListResponse, ErrorResponse | HTTPValidationError>({
      path: `/api/groups/${groupId}/members`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Add member to group (Admins only).
   *
   * @tags Groups
   * @name AddGroupMember
   * @summary Add Group Member
   * @request POST:/api/groups/{group_id}/members
   * @secure
   */
  addGroupMember = (
    groupId: string,
    query: {
      /** User Id */
      user_id: string;
      /**
       * Roles within a group.
       * @default "member"
       */
      role?: MemberRole;
    },
    params: RequestParams = {},
  ) =>
    this.request<OperationResponse, ErrorResponse | HTTPValidationError>({
      path: `/api/groups/${groupId}/members`,
      method: "POST",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Remove member from group.
   *
   * @tags Groups
   * @name RemoveGroupMember
   * @summary Remove Group Member
   * @request DELETE:/api/groups/{group_id}/members/{user_id}
   * @secure
   */
  removeGroupMember = (
    groupId: string,
    userId: string,
    params: RequestParams = {},
  ) =>
    this.request<OperationResponse, ErrorResponse | HTTPValidationError>({
      path: `/api/groups/${groupId}/members/${userId}`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Update member role and permissions.
   *
   * @tags Groups
   * @name UpdateGroupMember
   * @summary Update Group Member
   * @request PUT:/api/groups/{group_id}/members/{user_id}
   * @secure
   */
  updateGroupMember = (
    groupId: string,
    userId: string,
    data: GroupMemberUpdate,
    params: RequestParams = {},
  ) =>
    this.request<OperationResponse, ErrorResponse | HTTPValidationError>({
      path: `/api/groups/${groupId}/members/${userId}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Check if current user can share documents with this group.
   *
   * @tags Groups
   * @name CanShareDocument
   * @summary Can Share Document
   * @request GET:/api/groups/{group_id}/can-share
   * @secure
   */
  canShareDocument = (groupId: string, params: RequestParams = {}) =>
    this.request<CanShareResponse, ErrorResponse | HTTPValidationError>({
      path: `/api/groups/${groupId}/can-share`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Get audit log for group (Admins only).
   *
   * @tags Groups
   * @name GetGroupAuditLog
   * @summary Get Group Audit Log
   * @request GET:/api/groups/{group_id}/audit
   * @secure
   */
  getGroupAuditLog = (
    groupId: string,
    query?: {
      /**
       * Limit
       * @min 1
       * @max 500
       * @default 100
       */
      limit?: number;
      /**
       * Skip
       * @min 0
       * @default 0
       */
      skip?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<any, ErrorResponse | HTTPValidationError>({
      path: `/api/groups/${groupId}/audit`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description List all groups with pagination (System Admins only). Returns all groups in the system without access restrictions. Supports larger page sizes (up to 100 items per page).
   *
   * @tags Groups
   * @name AdminListAllGroups
   * @summary Admin List All Groups
   * @request GET:/api/groups/admin/all
   * @secure
   */
  adminListAllGroups = (
    query?: {
      /**
       * Page
       * Page number (1-indexed)
       * @min 1
       * @default 1
       */
      page?: number;
      /**
       * Page Size
       * Items per page
       * @min 1
       * @max 100
       * @default 50
       */
      page_size?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<GroupListResponse, ErrorResponse | HTTPValidationError>({
      path: `/api/groups/admin/all`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Get system-wide group statistics (System Admins only).
   *
   * @tags Groups
   * @name AdminGetGroupStats
   * @summary Admin Get Group Stats
   * @request GET:/api/groups/admin/stats
   * @secure
   */
  adminGetGroupStats = (params: RequestParams = {}) =>
    this.request<any, ErrorResponse | HTTPValidationError>({
      path: `/api/groups/admin/stats`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Search for users and/or groups for sharing functionality. Args: q: Search query types: Which types to search (users, groups, or both) limit: Maximum total results current_user: Authenticated user group_manager: GroupManager instance user_service: UserService instance Returns: Combined search results with type indicators
   *
   * @tags Search
   * @name SearchRecipients
   * @summary Search Recipients
   * @request GET:/api/search/recipients
   * @secure
   */
  searchRecipients = (
    query: {
      /**
       * Q
       * Search query
       * @minLength 1
       */
      q: string;
      /**
       * Types
       * Comma-separated list: users, groups
       * @default "users,groups"
       */
      types?: string;
      /**
       * Limit
       * Maximum total results
       * @min 1
       * @max 100
       * @default 20
       */
      limit?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<RecipientSearchResponse, ErrorResponse | HTTPValidationError>({
      path: `/api/search/recipients`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Search users only (convenience endpoint).
   *
   * @tags Search
   * @name SearchUsersOnly
   * @summary Search Users Only
   * @request GET:/api/search/users
   * @secure
   */
  searchUsersOnly = (
    query: {
      /**
       * Q
       * Search query
       * @minLength 1
       */
      q: string;
      /**
       * Limit
       * Maximum number of results
       * @min 1
       * @max 50
       * @default 10
       */
      limit?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<SearchResultsResponse, ErrorResponse | HTTPValidationError>({
      path: `/api/search/users`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Search groups only (convenience endpoint).
   *
   * @tags Search
   * @name SearchGroupsOnly
   * @summary Search Groups Only
   * @request GET:/api/search/groups
   * @secure
   */
  searchGroupsOnly = (
    query: {
      /**
       * Q
       * Search query
       * @minLength 1
       */
      q: string;
      /**
       * Limit
       * Maximum number of results
       * @min 1
       * @max 50
       * @default 10
       */
      limit?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<SearchResultsResponse, ErrorResponse | HTTPValidationError>({
      path: `/api/search/groups`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Get public organization information (name, branding, etc.). No authentication required.
   *
   * @tags System
   * @name GetPublicOrganizationInfo
   * @summary Get Public Organization Info
   * @request GET:/api/system/public/info
   * @secure
   */
  getPublicOrganizationInfo = (params: RequestParams = {}) =>
    this.request<any, any>({
      path: `/api/system/public/info`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Get the complete system organization details. Requires authentication.
   *
   * @tags System
   * @name GetSystemOrganization
   * @summary Get System Organization
   * @request GET:/api/system/
   * @secure
   */
  getSystemOrganization = (params: RequestParams = {}) =>
    this.request<any, ErrorResponse | HTTPValidationError>({
      path: `/api/system/`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Update the system organization. Admin only.
   *
   * @tags System
   * @name UpdateSystemOrganization
   * @summary Update System Organization
   * @request PUT:/api/system/
   * @secure
   */
  updateSystemOrganization = (
    data: OrganizationUpdate,
    params: RequestParams = {},
  ) =>
    this.request<any, ErrorResponse | HTTPValidationError>({
      path: `/api/system/`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Get organization settings.
   *
   * @tags System
   * @name GetOrganizationSettings
   * @summary Get Organization Settings
   * @request GET:/api/system/settings
   * @secure
   */
  getOrganizationSettings = (params: RequestParams = {}) =>
    this.request<any, ErrorResponse | HTTPValidationError>({
      path: `/api/system/settings`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Update organization settings. Admin only.
   *
   * @tags System
   * @name UpdateOrganizationSettings
   * @summary Update Organization Settings
   * @request PUT:/api/system/settings
   * @secure
   */
  updateOrganizationSettings = (
    data: SettingsUpdate,
    params: RequestParams = {},
  ) =>
    this.request<any, ErrorResponse | HTTPValidationError>({
      path: `/api/system/settings`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Update branding settings specifically. Admin only.
   *
   * @tags System
   * @name UpdateBrandingSettings
   * @summary Update Branding Settings
   * @request PUT:/api/system/settings/branding
   * @secure
   */
  updateBrandingSettings = (
    data: Record<string, any>,
    params: RequestParams = {},
  ) =>
    this.request<any, ErrorResponse | HTTPValidationError>({
      path: `/api/system/settings/branding`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Update feature flags. Admin only.
   *
   * @tags System
   * @name UpdateFeatureSettings
   * @summary Update Feature Settings
   * @request PUT:/api/system/settings/features
   * @secure
   */
  updateFeatureSettings = (
    data: Record<string, any>,
    params: RequestParams = {},
  ) =>
    this.request<any, ErrorResponse | HTTPValidationError>({
      path: `/api/system/settings/features`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Update security settings. Admin only.
   *
   * @tags System
   * @name UpdateSecuritySettings
   * @summary Update Security Settings
   * @request PUT:/api/system/settings/security
   * @secure
   */
  updateSecuritySettings = (
    data: Record<string, any>,
    params: RequestParams = {},
  ) =>
    this.request<any, ErrorResponse | HTTPValidationError>({
      path: `/api/system/settings/security`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Return all linked identities, available providers, and providers that failed to initialise (e.g. missing ENTRA_LINK_REDIRECT_URI). Response shape:: { "identities": { "<provider_key>": { ... } }, "available_providers": [ {"provider_key": str, "display_name": str} ], "unavailable_providers": [ {"provider_key": str, "reason": str} ] } ``unavailable_providers`` is additive — existing frontends ignore it. NOTE: the frontend (LinkedAccountsSection / useIdentityLink) does not render ``unavailable_providers`` yet — that is a follow-up task.
   *
   * @tags Identity Link
   * @name GetLinkStatus
   * @summary Get Link Status
   * @request GET:/api/identity-link/status
   * @secure
   */
  getLinkStatus = (params: RequestParams = {}) =>
    this.request<any, ErrorResponse | HTTPValidationError>({
      path: `/api/identity-link/status`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Identity Link
   * @name StartLink
   * @summary Start Link
   * @request GET:/api/identity-link/{provider_key}/start
   * @secure
   */
  startLink = (providerKey: string, params: RequestParams = {}) =>
    this.request<any, ErrorResponse | HTTPValidationError>({
      path: `/api/identity-link/${providerKey}/start`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Handle the OAuth redirect from the external provider. Public endpoint (no get_current_user): the browser is redirected here by the upstream IdP. The ``state`` token in Redis carries the originating user_id so we can persist the identity to the correct account. Rate-limited per (client IP, provider_key) before anything else runs -- this is a FastAPI dependency, and FastAPI resolves all of a route's dependencies before invoking the route body, so a caller who has exhausted the window gets a 429 without the state token ever being looked up, let alone consumed. State is validated before ``_resolve_handlers()`` runs, so a caller without a valid state (issued by our own ``/start`` endpoint) never reaches the DB reads and plugin discovery inside it. It is only *consumed* (deleted) once we know a registered handler exists for ``provider_key`` -- a transient discovery/DB hiccup that makes a provider look unknown must not burn the caller's one-time state.
   *
   * @tags Identity Link
   * @name LinkCallback
   * @summary Link Callback
   * @request GET:/api/identity-link/{provider_key}/callback
   * @secure
   */
  linkCallback = (
    providerKey: string,
    query?: {
      /** Code */
      code?: string | null;
      /** State */
      state?: string | null;
      /** Error */
      error?: string | null;
      /** Error Description */
      error_description?: string | null;
    },
    params: RequestParams = {},
  ) =>
    this.request<any, ErrorResponse | HTTPValidationError>({
      path: `/api/identity-link/${providerKey}/callback`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Identity Link
   * @name UnlinkIdentity
   * @summary Unlink Identity
   * @request DELETE:/api/identity-link/{provider_key}
   * @secure
   */
  unlinkIdentity = (providerKey: string, params: RequestParams = {}) =>
    this.request<UnlinkIdentityResponse, ErrorResponse | HTTPValidationError>({
      path: `/api/identity-link/${providerKey}`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Report which file types the server accepts for upload. The allow-list is environment-driven (image types are gated behind IMAGE_UPLOAD_ENABLED), so the frontend reads it here rather than hardcoding a list that can drift from the backend. Drives the upload dialog's accept filter and the "supported formats" hint. Authoritative gate stays in common.security.file_validation; this is a read-only projection of it.
   *
   * @tags Documents
   * @name GetUploadCapabilities
   * @summary Get Upload Capabilities
   * @request GET:/api/documents/upload/capabilities
   * @secure
   */
  getUploadCapabilities = (params: RequestParams = {}) =>
    this.request<
      UploadCapabilitiesResponse,
      ErrorResponse | HTTPValidationError
    >({
      path: `/api/documents/upload/capabilities`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Redirect to document view endpoint. Args: document_id: ID of the document Returns: RedirectResponse: Redirect to the appropriate endpoint
   *
   * @tags Documents
   * @name ViewDocument
   * @summary View Document
   * @request GET:/api/documents/document/view/{document_id}
   * @secure
   */
  viewDocument = (documentId: string, params: RequestParams = {}) =>
    this.request<any, ErrorResponse | HTTPValidationError>({
      path: `/api/documents/document/view/${documentId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Redirect to document download endpoint. Args: document_id: ID of the document Returns: RedirectResponse: Redirect to the appropriate endpoint
   *
   * @tags Documents
   * @name DownloadDocument
   * @summary Download Document
   * @request GET:/api/documents/document/download/{document_id}
   * @secure
   */
  downloadDocument = (documentId: string, params: RequestParams = {}) =>
    this.request<any, ErrorResponse | HTTPValidationError>({
      path: `/api/documents/document/download/${documentId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Get a paginated list of documents with filtering, sorting, and total count. Args: skip: Number of documents to skip (for pagination) limit: Maximum number of documents to return category: Optional category filter source_type: Optional source type filter (sap, custom, faq) visibility: Optional visibility filter (public, private, organization, group) owner_id: Optional owner ID filter sort_by: Optional sort order (newest, oldest, recently_updated, title_asc, title_desc) created_at_gte: Optional created date range start (ISO 8601 format) created_at_lte: Optional created date range end (ISO 8601 format) updated_at_gte: Optional updated date range start (ISO 8601 format) updated_at_lte: Optional updated date range end (ISO 8601 format) shared_with_group: Optional group ID filter (documents shared with specific group) shared_with_user: Optional user ID filter (documents shared with specific user) exclude_owned: Optional flag to exclude documents owned by current user (for "Shared with Me") current_user: Authenticated user Returns: DocumentListResponse: Paginated list of documents with total count
   *
   * @tags Documents
   * @name GetDocuments
   * @summary Get Documents
   * @request GET:/api/documents/
   * @secure
   */
  getDocuments = (
    query?: {
      /**
       * Skip
       * @default 0
       */
      skip?: number;
      /**
       * Limit
       * @default 20
       */
      limit?: number;
      /** Category */
      category?: string | null;
      /** Source Type */
      source_type?: string | null;
      /** Visibility */
      visibility?: string | null;
      /** Owner Id */
      owner_id?: string | null;
      /** Sort By */
      sort_by?: DocumentSortBy | null;
      /** Created At Gte */
      created_at_gte?: string | null;
      /** Created At Lte */
      created_at_lte?: string | null;
      /** Updated At Gte */
      updated_at_gte?: string | null;
      /** Updated At Lte */
      updated_at_lte?: string | null;
      /** Shared With Group */
      shared_with_group?: string | null;
      /** Shared With User */
      shared_with_user?: string | null;
      /**
       * Exclude Owned
       * @default false
       */
      exclude_owned?: boolean | null;
    },
    params: RequestParams = {},
  ) =>
    this.request<DocumentListResponse, ErrorResponse | HTTPValidationError>({
      path: `/api/documents/`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Create a new document from text content or URL. Args: document: Document creation data (text content or URL) current_user: Authenticated user Returns: Document: Created document object Raises: DocumentValidationError: If input validation fails (handled -> 400) DatabaseOperationError: If database operations fail (handled -> 500)
   *
   * @tags Documents
   * @name CreateDocument
   * @summary Create Document
   * @request POST:/api/documents/
   * @secure
   */
  createDocument = (
    data: DocumentCreate,
    query?: {
      /**
       * On Duplicate
       * @default "prompt"
       */
      on_duplicate?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<Document, ErrorResponse | HTTPValidationError>({
      path: `/api/documents/`,
      method: "POST",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Get all document IDs that the current user has access to. Registered before the ``/{document_id}`` wildcard so Starlette's registration-order matching does not capture the literal ``/my-documents`` path as a document id. Args: current_user: Authenticated user Returns: List of document hashes the user can access
   *
   * @tags Documents
   * @name GetMyAccessibleDocuments
   * @summary Get My Accessible Documents
   * @request GET:/api/documents/my-documents
   * @secure
   */
  getMyAccessibleDocuments = (params: RequestParams = {}) =>
    this.request<string[], ErrorResponse | HTTPValidationError>({
      path: `/api/documents/my-documents`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Set the same sharing on several documents. Same rules per document as ``PUT /{document_id}/permissions`` (owner only). A field left out keeps what each document has; an empty list clears it.
   *
   * @tags Documents
   * @name UpdateDocumentsPermissionsBulk
   * @summary Update Documents Permissions Bulk
   * @request POST:/api/documents/batch/permissions
   * @secure
   */
  updateDocumentsPermissionsBulk = (
    data: BulkDocumentPermissionsRequest,
    params: RequestParams = {},
  ) =>
    this.request<BulkDocumentsResponse, ErrorResponse | HTTPValidationError>({
      path: `/api/documents/batch/permissions`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Delete several documents, each with the cascade of the single delete. Same rules per document as ``DELETE /{document_id}``: own documents, or any document for an admin; SAP documentation only for an admin.
   *
   * @tags Documents
   * @name DeleteDocumentsBulk
   * @summary Delete Documents Bulk
   * @request POST:/api/documents/batch/delete
   * @secure
   */
  deleteDocumentsBulk = (
    data: BulkDocumentDeleteRequest,
    params: RequestParams = {},
  ) =>
    this.request<BulkDocumentsResponse, ErrorResponse | HTTPValidationError>({
      path: `/api/documents/batch/delete`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Get a document by ID. Args: document_id: ID of the document current_user: Authenticated user Returns: Document: Document object Raises: DocumentNotFoundError: If document doesn't exist (handled by exception handler -> 404) DocumentPermissionError: If user lacks read permission (handled -> 403)
   *
   * @tags Documents
   * @name GetDocument
   * @summary Get Document
   * @request GET:/api/documents/{document_id}
   * @secure
   */
  getDocument = (documentId: string, params: RequestParams = {}) =>
    this.request<Document, ErrorResponse | HTTPValidationError>({
      path: `/api/documents/${documentId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Update an existing document. Args: document_id: ID of the document to update document: Updated document data current_user: Authenticated user Returns: Document: Updated document object Raises: DocumentNotFoundError: If document doesn't exist (handled -> 404) DocumentPermissionError: If user lacks permission (handled -> 403) DatabaseOperationError: If update fails (handled -> 500)
   *
   * @tags Documents
   * @name UpdateDocument
   * @summary Update Document
   * @request PUT:/api/documents/{document_id}
   * @secure
   */
  updateDocument = (
    documentId: string,
    data: DocumentCreate,
    params: RequestParams = {},
  ) =>
    this.request<Document, ErrorResponse | HTTPValidationError>({
      path: `/api/documents/${documentId}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Delete a document with cascade deletion across all storage layers. Users can delete their own documents, admins can delete any document. Args: document_id: ID of the document to delete reason: Optional reason for deletion (for audit trail) current_user: Authenticated user Returns: Dict[str, Any]: Status message Raises: DocumentNotFoundError: If document doesn't exist (handled -> 404) DocumentPermissionError: If user lacks permission (handled -> 403) DatabaseOperationError: If deletion fails (handled -> 500)
   *
   * @tags Documents
   * @name DeleteDocument
   * @summary Delete Document
   * @request DELETE:/api/documents/{document_id}
   * @secure
   */
  deleteDocument = (
    documentId: string,
    query?: {
      /** Reason */
      reason?: string | null;
    },
    params: RequestParams = {},
  ) =>
    this.request<any, ErrorResponse | HTTPValidationError>({
      path: `/api/documents/${documentId}`,
      method: "DELETE",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Create a new document by uploading a file with DSGVO-compliant ACL settings. Only ``visibility``, ``shared_with_users`` and ``shared_with_groups`` are accepted for ACL purposes: the ``documents`` collection has no columns for processing purpose, retention period or sharing roles, so this endpoint does not offer fields it cannot persist (same contract as ``PUT /{document_id}/permissions``). Args: file: The uploaded file title: Optional title for the document (uses filename if not provided) category: Optional category for the document tags: Comma-separated tags visibility: Document visibility (private, organization, public) shared_with_users: Comma-separated user IDs to share with shared_with_groups: Comma-separated group names to share with legal_basis: Legal basis for processing (DSGVO) current_user: Authenticated user Returns: Document: Created document object with ACL information
   *
   * @tags Documents
   * @name UploadDocument
   * @summary Upload Document
   * @request POST:/api/documents/upload
   * @secure
   */
  uploadDocument = (
    data: BodyUploadDocumentApiDocumentsUploadPost,
    params: RequestParams = {},
  ) =>
    this.request<Document, ErrorResponse | HTTPValidationError>({
      path: `/api/documents/upload`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      format: "json",
      ...params,
    });
  /**
   * @description Update an existing document by uploading a new file. This will replace the document content and regenerate embeddings. ``title``, ``visibility``, ``tags`` and the sharing lists are accepted: the ``documents`` collection has no column for processing purpose (same contract as ``POST /upload`` and ``PUT /{document_id}/permissions``). Sharing lists are comma-separated ids; absent fields keep the existing sharing, an empty string clears it. Args: document_id: ID of the document to update file: New file to upload title: Optional new title visibility: Optional new visibility setting tags: Optional comma-separated tags current_user: Authenticated user organization: Current organization request: FastAPI request object Returns: Document: Updated document object
   *
   * @tags Documents
   * @name UpdateDocumentFile
   * @summary Update Document File
   * @request PUT:/api/documents/{document_id}/file
   * @secure
   */
  updateDocumentFile = (
    documentId: string,
    data: BodyUpdateDocumentFileApiDocumentsDocumentIdFilePut,
    params: RequestParams = {},
  ) =>
    this.request<Document, ErrorResponse | HTTPValidationError>({
      path: `/api/documents/${documentId}/file`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.FormData,
      format: "json",
      ...params,
    });
  /**
   * @description Re-run extraction and indexing for a stored document. Feeds the stored original through the ingest pipeline again so the index picks up pipeline improvements (page-based OCR of scanned pages, citation regions, sheet ranges) without a delete-and-re-upload. The old chunks stay searchable until the new ones are written (Write-Then-Flip). Requires write access to the document. Returns 202 with the job id; 409 while the document is already being processed; 400 when there is no stored original to re-read; 403 for anyone but the owner or an admin.
   *
   * @tags Documents
   * @name ReprocessDocument
   * @summary Reprocess Document
   * @request POST:/api/documents/{document_id}/reprocess
   * @secure
   */
  reprocessDocument = (documentId: string, params: RequestParams = {}) =>
    this.request<any, ErrorResponse | HTTPValidationError>({
      path: `/api/documents/${documentId}/reprocess`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Get a PDF preview of an Office document (DOCX/PPTX/XLSX and cousins). Browsers cannot render Office formats, so citation deep-links need a PDF stand-in. The preview is converted on first request with headless LibreOffice (fully local) and cached in object storage beside the original; later requests serve the cache. PDFs themselves never need this endpoint (the viewer loads /original directly). Returns 404 when the document or its original file does not exist, 415 when the file type has no PDF preview (e.g. images or plain text).
   *
   * @tags Documents
   * @name GetDocumentPdfPreview
   * @summary Get Document Pdf Preview
   * @request GET:/api/documents/{document_id}/preview
   * @secure
   */
  getDocumentPdfPreview = (documentId: string, params: RequestParams = {}) =>
    this.request<any, ErrorResponse | HTTPValidationError>({
      path: `/api/documents/${documentId}/preview`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Get the original document file. Args: document_id: ID of the document display: If true, display inline; if false, force download current_user: Authenticated user Returns: Response: File response with the original document Raises: DocumentNotFoundError: If document doesn't exist (handled -> 404) DocumentPermissionError: If user lacks access (handled -> 403)
   *
   * @tags Documents
   * @name GetOriginalDocument
   * @summary Get Original Document
   * @request GET:/api/documents/{document_id}/original
   * @secure
   */
  getOriginalDocument = (
    documentId: string,
    query?: {
      /**
       * Display
       * @default false
       */
      display?: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<any, ErrorResponse | HTTPValidationError>({
      path: `/api/documents/${documentId}/original`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Return a document's plain-text content as JSON, for in-app preview. Used by the chat source side-drawer to render text/manual sources inline instead of opening a raw-text browser tab. ACL-guarded like /original. Works for text-only/manual documents (no file) by reading the stored text. Capped so a huge document can't bloat the response; ``truncated`` signals it.
   *
   * @tags Documents
   * @name GetDocumentTextContent
   * @summary Get Document Text Content
   * @request GET:/api/documents/{document_id}/content
   * @secure
   */
  getDocumentTextContent = (documentId: string, params: RequestParams = {}) =>
    this.request<any, ErrorResponse | HTTPValidationError>({
      path: `/api/documents/${documentId}/content`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Return how the document's text was extracted (provenance) as JSON. Written at ingest: ``method`` (native / ocr_rapidocr / mixed_ocr_rapidocr / ocr_easyocr / mixed_ocr_easyocr / vlm_caption / ...), ``ocr_applied`` and, for OCR runs, ``ocr_pages`` with the recognizer confidence per page (mean and 10th percentile) so a reviewer can spot pages worth checking. ACL-guarded like /content. Returns ``extraction: null`` for documents indexed before this was recorded.
   *
   * @tags Documents
   * @name GetDocumentExtraction
   * @summary Get Document Extraction
   * @request GET:/api/documents/{document_id}/extraction
   * @secure
   */
  getDocumentExtraction = (documentId: string, params: RequestParams = {}) =>
    this.request<any, ErrorResponse | HTTPValidationError>({
      path: `/api/documents/${documentId}/extraction`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Return the document's analyzed figures (structured tables etc.) as JSON. Populated at ingest by the figure_analysis subsystem (when FIGURE_ANALYSIS_ENABLED). ACL-guarded like /content; figures inherit the parent document's access control. Returns an empty list when the document has no analyzed figures.
   *
   * @tags Documents
   * @name GetDocumentFigures
   * @summary Get Document Figures
   * @request GET:/api/documents/{document_id}/figures
   * @secure
   */
  getDocumentFigures = (documentId: string, params: RequestParams = {}) =>
    this.request<any, ErrorResponse | HTTPValidationError>({
      path: `/api/documents/${documentId}/figures`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Search for documents with DSGVO-compliant ACL filtering. Uses MongoDB text search on actual documents, not vector embeddings. Args: request: Search request current_user: Authenticated user Returns: SearchResponse: Search results filtered by ACL permissions
   *
   * @tags Documents
   * @name SearchDocuments
   * @summary Search Documents
   * @request POST:/api/documents/search
   * @secure
   */
  searchDocuments = (data: SearchRequest, params: RequestParams = {}) =>
    this.request<SearchResponse, ErrorResponse | HTTPValidationError>({
      path: `/api/documents/search`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Check user's access permissions to a specific document. Args: document_id: SHA-256 hash of the document current_user: Authenticated user Returns: AccessCheckResult: Detailed access information with anonymized sharing info
   *
   * @tags Documents
   * @name CheckDocumentAccess
   * @summary Check Document Access
   * @request GET:/api/documents/{document_id}/access
   * @secure
   */
  checkDocumentAccess = (documentId: string, params: RequestParams = {}) =>
    this.request<AccessCheckResult, ErrorResponse | HTTPValidationError>({
      path: `/api/documents/${documentId}/access`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Revoke user's access to a document (DSGVO right to deletion). Args: document_id: SHA-256 hash of the document current_user: Authenticated user Returns: Success message
   *
   * @tags Documents
   * @name RevokeDocumentAccess
   * @summary Revoke Document Access
   * @request DELETE:/api/documents/{document_id}/access
   * @secure
   */
  revokeDocumentAccess = (documentId: string, params: RequestParams = {}) =>
    this.request<OperationResponse, ErrorResponse | HTTPValidationError>({
      path: `/api/documents/${documentId}/access`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Update ACL permissions for a document (only for document owners). Only ``visibility``, ``shared_with_users`` and ``shared_with_groups`` are accepted: the ``documents`` collection has no columns for processing purpose, retention period, legal basis or sharing roles, so this endpoint does not offer fields it cannot persist. Args: document_id: SHA-256 hash of the document visibility: New visibility setting shared_with_users: Comma-separated user IDs to share with shared_with_groups: Comma-separated group names current_user: Authenticated user (must be owner) Returns: Success message
   *
   * @tags Documents
   * @name UpdateDocumentPermissions
   * @summary Update Document Permissions
   * @request PUT:/api/documents/{document_id}/permissions
   * @secure
   */
  updateDocumentPermissions = (
    documentId: string,
    data: BodyUpdateDocumentPermissionsApiDocumentsDocumentIdPermissionsPut,
    params: RequestParams = {},
  ) =>
    this.request<any, ErrorResponse | HTTPValidationError>({
      path: `/api/documents/${documentId}/permissions`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.UrlEncoded,
      format: "json",
      ...params,
    });
  /**
   * @description Get all conversations for the current user with pagination. Returns a paginated list of conversations sorted by last update time. Only active (non-archived) conversations are returned. Args: pagination: Pagination parameters (page, page_size) current_user: Authenticated user Returns: PaginatedResponse[ConversationSummary]: Paginated list of user's conversations
   *
   * @tags Conversations
   * @name GetConversations
   * @summary Get Conversations
   * @request GET:/api/conversations/
   * @secure
   */
  getConversations = (
    query?: {
      /**
       * Page
       * Page number (1-indexed)
       * @min 1
       * @default 1
       */
      page?: number;
      /**
       * Page Size
       * Items per page
       * @min 1
       * @max 100
       * @default 50
       */
      page_size?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      PaginatedResponseConversationSummary,
      ErrorResponse | HTTPValidationError
    >({
      path: `/api/conversations/`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Create a new conversation. Args: request: Conversation creation request current_user: Authenticated user Returns: ConversationSummary: Created conversation details
   *
   * @tags Conversations
   * @name CreateConversation
   * @summary Create Conversation
   * @request POST:/api/conversations/
   * @secure
   */
  createConversation = (
    data: CreateConversationRequest,
    params: RequestParams = {},
  ) =>
    this.request<ConversationSummary, ErrorResponse | HTTPValidationError>({
      path: `/api/conversations/`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Delete multiple conversations in bulk. This endpoint allows deleting multiple conversations at once. The operation is fault-tolerant - if some conversations fail to delete, others will still be processed. Users can only delete their own conversations. Args: request: Bulk delete request containing conversation IDs (1-100 IDs) current_user: Authenticated user Returns: BulkDeleteConversationsResponse: Results for each conversation deletion with counts Raises: HTTPException: 422 if validation fails (empty list or too many IDs)
   *
   * @tags Conversations
   * @name DeleteConversationsBulk
   * @summary Delete Conversations Bulk
   * @request DELETE:/api/conversations/batch
   * @secure
   */
  deleteConversationsBulk = (
    data: BulkDeleteConversationsRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      BulkDeleteConversationsResponse,
      ErrorResponse | HTTPValidationError
    >({
      path: `/api/conversations/batch`,
      method: "DELETE",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Get conversation details including messages. Args: conversation_id: ID of the conversation current_user: Authenticated user Returns: ConversationDetails: Full conversation with messages
   *
   * @tags Conversations
   * @name GetConversation
   * @summary Get Conversation
   * @request GET:/api/conversations/{conversation_id}
   * @secure
   */
  getConversation = (conversationId: string, params: RequestParams = {}) =>
    this.request<ConversationDetails, ErrorResponse | HTTPValidationError>({
      path: `/api/conversations/${conversationId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Update conversation details. Args: conversation_id: ID of the conversation request: Update request current_user: Authenticated user Returns: ConversationSummary: Updated conversation details
   *
   * @tags Conversations
   * @name UpdateConversation
   * @summary Update Conversation
   * @request PUT:/api/conversations/{conversation_id}
   * @secure
   */
  updateConversation = (
    conversationId: string,
    data: UpdateConversationRequest,
    params: RequestParams = {},
  ) =>
    this.request<ConversationSummary, ErrorResponse | HTTPValidationError>({
      path: `/api/conversations/${conversationId}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Delete a conversation and all its messages. Args: conversation_id: ID of the conversation current_user: Authenticated user Returns: StatusResponse: Operation status
   *
   * @tags Conversations
   * @name DeleteConversation
   * @summary Delete Conversation
   * @request DELETE:/api/conversations/{conversation_id}
   * @secure
   */
  deleteConversation = (conversationId: string, params: RequestParams = {}) =>
    this.request<StatusResponse, ErrorResponse | HTTPValidationError>({
      path: `/api/conversations/${conversationId}`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Get messages for a conversation with pagination. Returns messages in chronological order (oldest first) by message_index. Only accessible to the conversation owner. Args: conversation_id: ID of the conversation pagination: Pagination parameters (page, page_size) current_user: Authenticated user Returns: PaginatedResponse[MessageResponse]: Paginated conversation messages with sources
   *
   * @tags Conversations
   * @name GetConversationMessages
   * @summary Get Conversation Messages
   * @request GET:/api/conversations/{conversation_id}/messages
   * @secure
   */
  getConversationMessages = (
    conversationId: string,
    query?: {
      /**
       * Page
       * Page number (1-indexed)
       * @min 1
       * @default 1
       */
      page?: number;
      /**
       * Page Size
       * Items per page
       * @min 1
       * @max 100
       * @default 50
       */
      page_size?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      PaginatedResponseMessageResponse,
      ErrorResponse | HTTPValidationError
    >({
      path: `/api/conversations/${conversationId}/messages`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Clear all messages from a conversation. Args: conversation_id: ID of the conversation current_user: Authenticated user Returns: StatusResponse: Operation status
   *
   * @tags Conversations
   * @name ClearConversationMessages
   * @summary Clear Conversation Messages
   * @request DELETE:/api/conversations/{conversation_id}/messages
   * @secure
   */
  clearConversationMessages = (
    conversationId: string,
    params: RequestParams = {},
  ) =>
    this.request<StatusResponse, ErrorResponse | HTTPValidationError>({
      path: `/api/conversations/${conversationId}/messages`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Record thumbs-up / thumbs-down feedback on an assistant message. Idempotent: sending the same value again is a no-op; sending null clears the rating (used when the user toggles a vote off). Only the conversation owner may rate, and only assistant messages can be rated. Args: conversation_id: ID of the conversation the message belongs to message_id: ID of the assistant message being rated request: Feedback payload ('up', 'down', or null) current_user: Authenticated user Returns: MessageFeedbackResponse: The message ID and the stored feedback value Raises: HTTPException: 404 if no matching assistant message is found for this user
   *
   * @tags Conversations
   * @name SetMessageFeedback
   * @summary Set Message Feedback
   * @request PUT:/api/conversations/{conversation_id}/messages/{message_id}/feedback
   * @secure
   */
  setMessageFeedback = (
    conversationId: string,
    messageId: string,
    data: MessageFeedbackRequest,
    params: RequestParams = {},
  ) =>
    this.request<MessageFeedbackResponse, ErrorResponse | HTTPValidationError>({
      path: `/api/conversations/${conversationId}/messages/${messageId}/feedback`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Search conversations by title or content. Args: q: Search query limit: Maximum results to return current_user: Authenticated user Returns: List[ConversationSummary]: Matching conversations
   *
   * @tags Conversations
   * @name SearchConversations
   * @summary Search Conversations
   * @request GET:/api/conversations/search/
   * @secure
   */
  searchConversations = (
    query: {
      /**
       * Q
       * Search query
       */
      q: string;
      /**
       * Limit
       * Maximum results to return
       * @default 10
       */
      limit?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<ConversationSummary[], ErrorResponse | HTTPValidationError>({
      path: `/api/conversations/search/`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Download one conversation as a file. Reading goes through get_conversation_details, which filters by user_id, so a user can only ever export their own conversation - the same rule that makes sharing a link useless and this endpoint necessary.
   *
   * @tags Conversations
   * @name ExportConversation
   * @summary Unterhaltung exportieren
   * @request GET:/api/conversations/{conversation_id}/export
   * @secure
   */
  exportConversation = (
    conversationId: string,
    query?: {
      /**
       * Format
       * md keeps the structure, txt is plain text
       * @default "md"
       */
      format?: "md" | "txt";
    },
    params: RequestParams = {},
  ) =>
    this.request<any, ErrorResponse | HTTPValidationError>({
      path: `/api/conversations/${conversationId}/export`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Download several conversations as one ZIP. Fault-tolerant like the bulk delete next to it: a conversation that cannot be read is skipped rather than failing the whole archive, because a partial export is more useful than none. Only if nothing at all could be read does this answer 404.
   *
   * @tags Conversations
   * @name ExportConversationsBulk
   * @summary Mehrere Unterhaltungen exportieren
   * @request POST:/api/conversations/export
   * @secure
   */
  exportConversationsBulk = (
    data: BulkExportConversationsRequest,
    params: RequestParams = {},
  ) =>
    this.request<any, ErrorResponse | HTTPValidationError>({
      path: `/api/conversations/export`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Send a chat message within a specific conversation. Supports both streaming and non-streaming responses based on request.stream parameter. Args: conversation_id: ID of the conversation request: Chat request with messages and optional stream parameter auth_context: Authentication context with user and organization Returns: ChatResponse or StreamingResponse: Generated response
   *
   * @tags Conversation Chat
   * @name ChatInConversation
   * @summary Chat In Conversation
   * @request POST:/api/conversations/{conversation_id}/chat
   * @secure
   */
  chatInConversation = (
    conversationId: string,
    data: ChatRequest,
    params: RequestParams = {},
  ) =>
    this.request<any, ErrorResponse | HTTPValidationError>({
      path: `/api/conversations/${conversationId}/chat`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Generate a title for a conversation based on its first message. Args: conversation_id: ID of the conversation auth_context: Authentication context with user and organization Returns: dict: Generated title
   *
   * @tags Conversation Chat
   * @name GenerateConversationTitle
   * @summary Generate Conversation Title
   * @request GET:/api/conversations/{conversation_id}/generate-title
   * @secure
   */
  generateConversationTitle = (
    conversationId: string,
    params: RequestParams = {},
  ) =>
    this.request<Record<string, any>, ErrorResponse | HTTPValidationError>({
      path: `/api/conversations/${conversationId}/generate-title`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Debug endpoint: run retrieval pipeline and return full diagnostics. Returns top retrieved document titles + scores (post-ACL), stage-level counts, and fallback execution details — without calling the LLM. **Admin-only.** Only available when ``RAG_DEBUG_RETRIEVAL=true``. Args: query: The query text to embed and retrieve against. current_user: Authenticated user (must be admin or superadmin). Returns: dict: Retrieval diagnostics including per-document scores, stage counts, and fallback parameters.
   *
   * @tags Conversation Chat
   * @name DebugRetrievalDiagnostics
   * @summary Debug Retrieval Diagnostics
   * @request GET:/api/conversations/debug/retrieval
   * @secure
   */
  debugRetrievalDiagnostics = (
    query: {
      /**
       * Query
       * The query to run retrieval diagnostics on
       */
      query: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<Record<string, any>, ErrorResponse | HTTPValidationError>({
      path: `/api/conversations/debug/retrieval`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Extract PEM private key, public certificate, and SHA-1 thumbprint from an uploaded PFX/PKCS12 file. Used by the document-source admin UI as an alternative to specifying a PFX path on disk. Nothing is persisted server-side — the response is rendered into the form's certificate fields, then saved as part of the provider config like any other input.
   *
   * @tags Document Sources
   * @name ParsePfx
   * @summary Parse Pfx
   * @request POST:/api/document-sources/admin/parse-pfx
   * @secure
   */
  parsePfx = (
    data: BodyParsePfxApiDocumentSourcesAdminParsePfxPost,
    params: RequestParams = {},
  ) =>
    this.request<ParsedPfxResponse, ErrorResponse | HTTPValidationError>({
      path: `/api/document-sources/admin/parse-pfx`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      format: "json",
      ...params,
    });
  /**
   * @description Create a new admin-level provider configuration for single-tenant system.
   *
   * @tags Document Sources
   * @name CreateProviderConfig
   * @summary Create Provider Config
   * @request POST:/api/document-sources/admin/provider-configs
   * @secure
   */
  createProviderConfig = (
    data: DocumentSourceProviderConfigRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      DocumentSourceProviderConfigResponse,
      ErrorResponse | HTTPValidationError
    >({
      path: `/api/document-sources/admin/provider-configs`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Get all admin-level provider configurations for single-tenant system.
   *
   * @tags Document Sources
   * @name GetProviderConfigs
   * @summary Get Provider Configs
   * @request GET:/api/document-sources/admin/provider-configs
   * @secure
   */
  getProviderConfigs = (params: RequestParams = {}) =>
    this.request<
      DocumentSourceProviderConfigResponse[],
      ErrorResponse | HTTPValidationError
    >({
      path: `/api/document-sources/admin/provider-configs`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Get a specific admin-level provider configuration (secrets masked).
   *
   * @tags Document Sources
   * @name GetProviderConfig
   * @summary Get Provider Config
   * @request GET:/api/document-sources/admin/provider-configs/{config_id}
   * @secure
   */
  getProviderConfig = (configId: string, params: RequestParams = {}) =>
    this.request<
      DocumentSourceProviderConfigResponse,
      ErrorResponse | HTTPValidationError
    >({
      path: `/api/document-sources/admin/provider-configs/${configId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Update an admin-level provider configuration.
   *
   * @tags Document Sources
   * @name UpdateProviderConfig
   * @summary Update Provider Config
   * @request PUT:/api/document-sources/admin/provider-configs/{config_id}
   * @secure
   */
  updateProviderConfig = (
    configId: string,
    data: DocumentSourceProviderConfigRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      DocumentSourceProviderConfigResponse,
      ErrorResponse | HTTPValidationError
    >({
      path: `/api/document-sources/admin/provider-configs/${configId}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Schedule deletion of an admin-level provider configuration. The config is immediately marked as ``pending_deletion`` and all of its user connections are disabled. Documents, vectors, sync history and the config row itself are removed asynchronously by the cleanup job.
   *
   * @tags Document Sources
   * @name DeleteProviderConfig
   * @summary Delete Provider Config
   * @request DELETE:/api/document-sources/admin/provider-configs/{config_id}
   * @secure
   */
  deleteProviderConfig = (configId: string, params: RequestParams = {}) =>
    this.request<
      ProviderConfigDeletionResponse,
      ErrorResponse | HTTPValidationError
    >({
      path: `/api/document-sources/admin/provider-configs/${configId}`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Trigger a full re-sync for every connection bound to this config. Used by the admin UI's "Sync now" button. Fans out one RQ job per connection (admin-owned or user-owned). For external-ACL providers (SharePoint, Teams) this re-pulls all files from the upstream source into Qdrant; ACL filtering happens at query time independently.
   *
   * @tags Document Sources
   * @name AdminSyncProviderConfig
   * @summary Admin Sync Provider Config
   * @request POST:/api/document-sources/admin/provider-configs/{config_id}/sync
   * @secure
   */
  adminSyncProviderConfig = (configId: string, params: RequestParams = {}) =>
    this.request<any, ErrorResponse | HTTPValidationError>({
      path: `/api/document-sources/admin/provider-configs/${configId}/sync`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Aggregate sync status across all connections under a provider config.
   *
   * @tags Document Sources
   * @name AdminGetProviderConfigSyncStatus
   * @summary Admin Get Provider Config Sync Status
   * @request GET:/api/document-sources/admin/provider-configs/{config_id}/sync-status
   * @secure
   */
  adminGetProviderConfigSyncStatus = (
    configId: string,
    params: RequestParams = {},
  ) =>
    this.request<ProviderConfigSyncStatus, ErrorResponse | HTTPValidationError>(
      {
        path: `/api/document-sources/admin/provider-configs/${configId}/sync-status`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      },
    );
  /**
   * @description Create a new user connection to a document source.
   *
   * @tags Document Sources
   * @name CreateUserConnection
   * @summary Create User Connection
   * @request POST:/api/document-sources/user/connections
   * @secure
   */
  createUserConnection = (
    data: DocumentSourceUserConnectionRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      DocumentSourceUserConnectionResponse,
      ErrorResponse | HTTPValidationError
    >({
      path: `/api/document-sources/user/connections`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Get all user connections for the current user.
   *
   * @tags Document Sources
   * @name GetUserConnections
   * @summary Get User Connections
   * @request GET:/api/document-sources/user/connections
   * @secure
   */
  getUserConnections = (params: RequestParams = {}) =>
    this.request<
      DocumentSourceUserConnectionResponse[],
      ErrorResponse | HTTPValidationError
    >({
      path: `/api/document-sources/user/connections`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Get a specific user connection.
   *
   * @tags Document Sources
   * @name GetUserConnection
   * @summary Get User Connection
   * @request GET:/api/document-sources/user/connections/{connection_id}
   * @secure
   */
  getUserConnection = (connectionId: string, params: RequestParams = {}) =>
    this.request<
      DocumentSourceUserConnectionResponse,
      ErrorResponse | HTTPValidationError
    >({
      path: `/api/document-sources/user/connections/${connectionId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Update a user connection.
   *
   * @tags Document Sources
   * @name UpdateUserConnection
   * @summary Update User Connection
   * @request PUT:/api/document-sources/user/connections/{connection_id}
   * @secure
   */
  updateUserConnection = (
    connectionId: string,
    data: DocumentSourceUserConnectionRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      DocumentSourceUserConnectionResponse,
      ErrorResponse | HTTPValidationError
    >({
      path: `/api/document-sources/user/connections/${connectionId}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Delete a user connection.
   *
   * @tags Document Sources
   * @name DeleteUserConnection
   * @summary Delete User Connection
   * @request DELETE:/api/document-sources/user/connections/{connection_id}
   * @secure
   */
  deleteUserConnection = (connectionId: string, params: RequestParams = {}) =>
    this.request<OperationResponse, ErrorResponse | HTTPValidationError>({
      path: `/api/document-sources/user/connections/${connectionId}`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Get sync status for a user connection.
   *
   * @tags Document Sources
   * @name GetSyncStatus
   * @summary Get Sync Status
   * @request GET:/api/document-sources/user/connections/{connection_id}/sync-status
   * @secure
   */
  getSyncStatus = (connectionId: string, params: RequestParams = {}) =>
    this.request<ConnectionSyncStatus, ErrorResponse | HTTPValidationError>({
      path: `/api/document-sources/user/connections/${connectionId}/sync-status`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Get statistics for a user connection.
   *
   * @tags Document Sources
   * @name GetConnectionStats
   * @summary Get Connection Stats
   * @request GET:/api/document-sources/user/connections/{connection_id}/stats
   * @secure
   */
  getConnectionStats = (connectionId: string, params: RequestParams = {}) =>
    this.request<
      DocumentSourceSyncStatsResponse,
      ErrorResponse | HTTPValidationError
    >({
      path: `/api/document-sources/user/connections/${connectionId}/stats`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Get all user connections (admin only).
   *
   * @tags Document Sources
   * @name AdminGetAllConnections
   * @summary Admin Get All Connections
   * @request GET:/api/document-sources/admin/all-connections
   * @secure
   */
  adminGetAllConnections = (params: RequestParams = {}) =>
    this.request<
      DocumentSourceUserConnectionResponse[],
      ErrorResponse | HTTPValidationError
    >({
      path: `/api/document-sources/admin/all-connections`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Get system-wide document source statistics (admin only).
   *
   * @tags Document Sources
   * @name AdminGetSystemStats
   * @summary Admin Get System Stats
   * @request GET:/api/document-sources/admin/stats
   * @secure
   */
  adminGetSystemStats = (params: RequestParams = {}) =>
    this.request<any, ErrorResponse | HTTPValidationError>({
      path: `/api/document-sources/admin/stats`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Get available document source providers.
   *
   * @tags Document Sources
   * @name GetAvailableProviders
   * @summary Get Available Providers
   * @request GET:/api/document-sources/providers
   * @secure
   */
  getAvailableProviders = (params: RequestParams = {}) =>
    this.request<any, ErrorResponse | HTTPValidationError>({
      path: `/api/document-sources/providers`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Browse files and folders in SharePoint connection for selection.
   *
   * @tags Document Sources
   * @name BrowseSharepointFiles
   * @summary Browse Sharepoint Files
   * @request POST:/api/document-sources/user/connections/{connection_id}/browse-files
   * @secure
   */
  browseSharepointFiles = (
    connectionId: string,
    data: Record<string, any>,
    params: RequestParams = {},
  ) =>
    this.request<any, ErrorResponse | HTTPValidationError>({
      path: `/api/document-sources/user/connections/${connectionId}/browse-files`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Start sync with only selected files from file tree. Dispatches based on the provider's ``external_acl_mode``: * non-``"none"`` (e.g. SharePoint, Teams) → enqueue to the document- processor RQ worker which runs the ``DocumentSourceOrchestrator`` against Qdrant directly. * ``"none"`` (legacy Mongo-backed providers) → fall through to the existing in-process background task (kept for compatibility).
   *
   * @tags Document Sources
   * @name SyncSelectedFiles
   * @summary Sync Selected Files
   * @request POST:/api/document-sources/user/connections/{connection_id}/sync-selected
   * @secure
   */
  syncSelectedFiles = (
    connectionId: string,
    data: Record<string, any>,
    params: RequestParams = {},
  ) =>
    this.request<any, ErrorResponse | HTTPValidationError>({
      path: `/api/document-sources/user/connections/${connectionId}/sync-selected`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Refresh external-ACL payloads on all Qdrant points for this connection. No-op for plugins with ``external_acl_mode == "none"`` (Mongo-backed ACL doesn't live on Qdrant payloads).
   *
   * @tags Document Sources
   * @name RefreshConnectionAcls
   * @summary Refresh Connection Acls
   * @request POST:/api/document-sources/user/connections/{connection_id}/refresh-acls
   * @secure
   */
  refreshConnectionAcls = (connectionId: string, params: RequestParams = {}) =>
    this.request<any, ErrorResponse | HTTPValidationError>({
      path: `/api/document-sources/user/connections/${connectionId}/refresh-acls`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Get recursive file listing for a SharePoint connection.
   *
   * @tags Document Sources
   * @name RecursiveFileScan
   * @summary Recursive File Scan
   * @request GET:/api/document-sources/user/connections/{connection_id}/recursive-scan
   * @secure
   */
  recursiveFileScan = (
    connectionId: string,
    query?: {
      /**
       * Folder Path
       * @default "/"
       */
      folder_path?: string;
      /**
       * Max Depth
       * @default 5
       */
      max_depth?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<any, ErrorResponse | HTTPValidationError>({
      path: `/api/document-sources/user/connections/${connectionId}/recursive-scan`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Erstellt einen neuen FAQ als Document.
   *
   * @tags FAQ Documents
   * @name CreateFaq
   * @summary FAQ erstellen
   * @request POST:/api/faq-documents
   * @secure
   */
  createFaq = (data: FAQDocumentCreate, params: RequestParams = {}) =>
    this.request<FAQDocumentResponse, ErrorResponse | HTTPValidationError>({
      path: `/api/faq-documents`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description List FAQs with filtering, pagination, and sorting.
   *
   * @tags FAQ Documents
   * @name ListFaqs
   * @summary FAQs auflisten
   * @request GET:/api/faq-documents
   * @secure
   */
  listFaqs = (
    query?: {
      /**
       * Status Filter
       * Filter by status
       */
      status_filter?: FAQStatus | null;
      /**
       * Approval Status
       * Filter by approval status
       */
      approval_status?: string | null;
      /**
       * Category
       * Filter by category
       */
      category?: string | null;
      /**
       * Sort By
       * Sort order (newest, oldest, best_rated)
       */
      sort_by?: FAQSortBy | null;
      /**
       * Owned Only
       * Only FAQs the caller owns, across every approval status. This narrows the result - it never widens it, so it needs no role check.
       * @default false
       */
      owned_only?: boolean;
      /**
       * Page
       * Page number
       * @min 1
       * @default 1
       */
      page?: number;
      /**
       * Page Size
       * Items per page
       * @min 1
       * @max 100
       * @default 20
       */
      page_size?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<FAQListResponse, ErrorResponse | HTTPValidationError>({
      path: `/api/faq-documents`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Number of FAQs awaiting review, for the navigation badge. The badge polls this on every page, so it must stay cheap: one counting query instead of the twelve that /stats runs. Same scope as /stats, so the badge and the moderation list can never disagree.
   *
   * @tags FAQ Documents
   * @name GetFaqPendingCount
   * @summary Anzahl der FAQs in Pruefung
   * @request GET:/api/faq-documents/pending-count
   * @secure
   */
  getFaqPendingCount = (params: RequestParams = {}) =>
    this.request<FAQPendingCountResponse, ErrorResponse | HTTPValidationError>({
      path: `/api/faq-documents/pending-count`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Get FAQ statistics.
   *
   * @tags FAQ Documents
   * @name GetFaqStats
   * @summary FAQ Statistiken
   * @request GET:/api/faq-documents/stats
   * @secure
   */
  getFaqStats = (params: RequestParams = {}) =>
    this.request<FAQStatsResponse, ErrorResponse | HTTPValidationError>({
      path: `/api/faq-documents/stats`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Search FAQs using vector search.
   *
   * @tags FAQ Documents
   * @name SearchFaqs
   * @summary FAQs durchsuchen
   * @request GET:/api/faq-documents/search
   * @secure
   */
  searchFaqs = (
    query: {
      /**
       * Query
       * Search query
       */
      query: string;
      /**
       * Limit
       * Max results
       * @min 1
       * @max 50
       * @default 10
       */
      limit?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<FAQSearchResponse, ErrorResponse | HTTPValidationError>({
      path: `/api/faq-documents/search`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Get FAQ details.
   *
   * @tags FAQ Documents
   * @name GetFaq
   * @summary FAQ Details
   * @request GET:/api/faq-documents/{faq_id}
   * @secure
   */
  getFaq = (faqId: string, params: RequestParams = {}) =>
    this.request<FAQDocumentResponse, ErrorResponse | HTTPValidationError>({
      path: `/api/faq-documents/${faqId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Update FAQ content.
   *
   * @tags FAQ Documents
   * @name UpdateFaq
   * @summary FAQ aktualisieren
   * @request PUT:/api/faq-documents/{faq_id}
   * @secure
   */
  updateFaq = (
    faqId: string,
    data: FAQDocumentUpdate,
    params: RequestParams = {},
  ) =>
    this.request<FAQDocumentResponse, ErrorResponse | HTTPValidationError>({
      path: `/api/faq-documents/${faqId}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Delete FAQ (admin/moderator only).
   *
   * @tags FAQ Documents
   * @name DeleteFaq
   * @summary FAQ löschen
   * @request DELETE:/api/faq-documents/{faq_id}
   * @secure
   */
  deleteFaq = (faqId: string, params: RequestParams = {}) =>
    this.request<Record<string, any>, ErrorResponse | HTTPValidationError>({
      path: `/api/faq-documents/${faqId}`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Update FAQ status (submit, approve, publish, reject, archive).
   *
   * @tags FAQ Documents
   * @name UpdateFaqStatus
   * @summary FAQ Status ändern
   * @request POST:/api/faq-documents/{faq_id}/status
   * @secure
   */
  updateFaqStatus = (
    faqId: string,
    data: FAQStatusUpdate,
    params: RequestParams = {},
  ) =>
    this.request<FAQDocumentResponse, ErrorResponse | HTTPValidationError>({
      path: `/api/faq-documents/${faqId}/status`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Submit FAQ for approval by moderators. Only the owner can submit their own FAQ.
   *
   * @tags FAQ Documents
   * @name SubmitFaqForApproval
   * @summary FAQ zur Freigabe einreichen
   * @request POST:/api/faq-documents/{faq_id}/submit
   * @secure
   */
  submitFaqForApproval = (faqId: string, params: RequestParams = {}) =>
    this.request<FAQDocumentResponse, ErrorResponse | HTTPValidationError>({
      path: `/api/faq-documents/${faqId}/submit`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Approve FAQ. Requires appropriate moderation privileges based on FAQ visibility.
   *
   * @tags FAQ Documents
   * @name ApproveFaq
   * @summary FAQ freigeben
   * @request POST:/api/faq-documents/{faq_id}/approve
   * @secure
   */
  approveFaq = (faqId: string, params: RequestParams = {}) =>
    this.request<FAQDocumentResponse, ErrorResponse | HTTPValidationError>({
      path: `/api/faq-documents/${faqId}/approve`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Reject FAQ with reason. Requires appropriate moderation privileges. Args: faq_id: FAQ document ID to reject rejection_reason: Reason for rejection (10-500 characters, sanitized to prevent XSS) current_user: Authenticated user with moderator/admin privileges faq_service: FAQ service dependency Returns: Rejected FAQ document Raises: HTTPException: 400 if rejection_reason invalid, 403 if not moderator, 404 if FAQ not found
   *
   * @tags FAQ Documents
   * @name RejectFaq
   * @summary FAQ ablehnen
   * @request POST:/api/faq-documents/{faq_id}/reject
   * @secure
   */
  rejectFaq = (
    faqId: string,
    query: {
      /**
       * Rejection Reason
       * Rejection reason (10-500 characters required)
       * @minLength 10
       * @maxLength 500
       */
      rejection_reason: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<FAQDocumentResponse, ErrorResponse | HTTPValidationError>({
      path: `/api/faq-documents/${faqId}/reject`,
      method: "POST",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Publish FAQ (moderator only).
   *
   * @tags FAQ Documents
   * @name PublishFaq
   * @summary FAQ veröffentlichen
   * @request POST:/api/faq-documents/{faq_id}/publish
   * @secure
   */
  publishFaq = (faqId: string, params: RequestParams = {}) =>
    this.request<FAQDocumentResponse, ErrorResponse | HTTPValidationError>({
      path: `/api/faq-documents/${faqId}/publish`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Rate an FAQ as helpful or not helpful.
   *
   * @tags FAQ Documents
   * @name RateFaq
   * @summary FAQ bewerten
   * @request POST:/api/faq-documents/{faq_id}/rate
   * @secure
   */
  rateFaq = (
    faqId: string,
    query: {
      /**
       * Helpful
       * True if helpful, False if not helpful
       */
      helpful: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<FAQDocumentResponse, ErrorResponse | HTTPValidationError>({
      path: `/api/faq-documents/${faqId}/rate`,
      method: "POST",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Remove a user's vote from an FAQ.
   *
   * @tags FAQ Documents
   * @name UnrateFaq
   * @summary FAQ-Bewertung entfernen
   * @request DELETE:/api/faq-documents/{faq_id}/rate
   * @secure
   */
  unrateFaq = (faqId: string, params: RequestParams = {}) =>
    this.request<FAQDocumentResponse, ErrorResponse | HTTPValidationError>({
      path: `/api/faq-documents/${faqId}/rate`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Get system statistics. Single-tenant system.
   *
   * @tags Admin
   * @name GetSystemStats
   * @summary Get System Statistics
   * @request GET:/api/admin/stats/system
   * @secure
   */
  getSystemStats = (params: RequestParams = {}) =>
    this.request<any, ErrorResponse | HTTPValidationError>({
      path: `/api/admin/stats/system`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Get recent system errors. Single-tenant system.
   *
   * @tags Admin
   * @name GetRecentErrors
   * @summary Get Recent Errors
   * @request GET:/api/admin/errors
   * @secure
   */
  getRecentErrors = (
    query?: {
      /**
       * Limit
       * @default 20
       */
      limit?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<any, ErrorResponse | HTTPValidationError>({
      path: `/api/admin/errors`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Get document processing queue status. Single-tenant system.
   *
   * @tags Admin
   * @name GetProcessingQueue
   * @summary Get Document Processing Queue
   * @request GET:/api/admin/queue
   * @secure
   */
  getProcessingQueue = (
    query?: {
      /**
       * Limit
       * @default 20
       */
      limit?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<any, ErrorResponse | HTTPValidationError>({
      path: `/api/admin/queue`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description System health check endpoint.
   *
   * @tags Admin
   * @name HealthCheckApiAdminHealthGet
   * @summary Health Check
   * @request GET:/api/admin/health
   * @secure
   */
  healthCheckApiAdminHealthGet = (params: RequestParams = {}) =>
    this.request<any, ErrorResponse | HTTPValidationError>({
      path: `/api/admin/health`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description ADMIN-ONLY: set or clear the Redis-backed retrieval kill-switch (§9.1 leak-containment SLA). ``{"enabled": false}`` halts all chat retrieval within milliseconds. ``{"enabled": true}`` re-enables retrieval. The kill-switch is fail-closed: if Redis is unreachable when the chat endpoint reads it, retrieval is denied (503).
   *
   * @tags Admin
   * @name SetRetrievalKillSwitch
   * @summary Set or clear the RAG retrieval kill-switch
   * @request POST:/api/admin/retrieval-kill-switch
   * @secure
   */
  setRetrievalKillSwitch = (
    data: RetrievalKillSwitchRequest,
    params: RequestParams = {},
  ) =>
    this.request<any, ErrorResponse | HTTPValidationError>({
      path: `/api/admin/retrieval-kill-switch`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description ADMIN-ONLY: set or clear the Redis-backed FAQ mutation freeze (AE-11 Qdrant collection recreation guard). ``?enabled=true`` blocks all FAQ approve/reject endpoints within milliseconds. ``?enabled=false`` re-enables FAQ mutations. The freeze is fail-closed: if Redis is unreachable when an approve/reject endpoint reads it, the mutation is denied (503).
   *
   * @tags Admin
   * @name SetFaqMutationFreeze
   * @summary Enable or disable the FAQ mutation freeze
   * @request POST:/api/admin/faq-mutation-freeze
   * @secure
   */
  setFaqMutationFreeze = (
    query: {
      /**
       * Enabled
       * true = freeze FAQ mutations; false = re-enable
       */
      enabled: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<any, ErrorResponse | HTTPValidationError>({
      path: `/api/admin/faq-mutation-freeze`,
      method: "POST",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description ADMIN-ONLY: Set ``acl_locked=False`` on ALL Qdrant points for this document. Bypasses the set_acl_payload lock-check intentionally — this IS the unlock action. Idempotent: running twice on an already-unlocked document returns ``previous_locked=0``.
   *
   * @tags Admin
   * @name AclUnlockDocument
   * @summary Unlock a document's ACL (clear acl_locked flag in Qdrant)
   * @request POST:/api/admin/documents/{document_id}/acl-unlock
   * @secure
   */
  aclUnlockDocument = (documentId: string, params: RequestParams = {}) =>
    this.request<any, ErrorResponse | HTTPValidationError>({
      path: `/api/admin/documents/${documentId}/acl-unlock`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Get overall system status and statistics.
   *
   * @tags Server Admin
   * @name GetSystemStatus
   * @summary Get System Status
   * @request GET:/api/server-admin/status
   * @secure
   */
  getSystemStatus = (params: RequestParams = {}) =>
    this.request<SystemStatusResponse, ErrorResponse | HTTPValidationError>({
      path: `/api/server-admin/status`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Clean up all data from MongoDB, Qdrant, and S3. WARNING: This is destructive!
   *
   * @tags Server Admin
   * @name CleanupAllData
   * @summary Cleanup All Data
   * @request POST:/api/server-admin/cleanup/all
   * @secure
   */
  cleanupAllData = (params: RequestParams = {}) =>
    this.request<SystemCleanupResponse, ErrorResponse | HTTPValidationError>({
      path: `/api/server-admin/cleanup/all`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Fix duplicate ACL entries by removing duplicates.
   *
   * @tags Server Admin
   * @name FixDuplicateAclEntries
   * @summary Fix Duplicate Acl Entries
   * @request POST:/api/server-admin/fix/duplicate-acl
   * @secure
   */
  fixDuplicateAclEntries = (params: RequestParams = {}) =>
    this.request<SystemCleanupResponse, ErrorResponse | HTTPValidationError>({
      path: `/api/server-admin/fix/duplicate-acl`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Recreate Qdrant collection with fresh schema.
   *
   * @tags Server Admin
   * @name RecreateQdrantCollection
   * @summary Recreate Qdrant Collection
   * @request POST:/api/server-admin/recreate-qdrant/{collection_name}
   * @secure
   */
  recreateQdrantCollection = (
    collectionName: string,
    params: RequestParams = {},
  ) =>
    this.request<QdrantCollectionResponse, ErrorResponse | HTTPValidationError>(
      {
        path: `/api/server-admin/recreate-qdrant/${collectionName}`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      },
    );
  /**
   * @description Get SMTP configuration from database or environment variables.
   *
   * @tags Server Admin
   * @name GetSmtpConfig
   * @summary Get Smtp Config
   * @request GET:/api/server-admin/config/smtp
   * @secure
   */
  getSmtpConfig = (params: RequestParams = {}) =>
    this.request<
      SMTPConfigurationResponse,
      ErrorResponse | HTTPValidationError
    >({
      path: `/api/server-admin/config/smtp`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Save SMTP configuration to database.
   *
   * @tags Server Admin
   * @name SaveSmtpConfig
   * @summary Save Smtp Config
   * @request POST:/api/server-admin/config/smtp
   * @secure
   */
  saveSmtpConfig = (
    data: Record<string, string | number | boolean>,
    params: RequestParams = {},
  ) =>
    this.request<
      SMTPConfigurationResponse,
      ErrorResponse | HTTPValidationError
    >({
      path: `/api/server-admin/config/smtp`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Get comprehensive system health and performance metrics.
   *
   * @tags Performance
   * @name GetSystemHealth
   * @summary Get System Health
   * @request GET:/api/admin/performance/health
   * @secure
   */
  getSystemHealth = (params: RequestParams = {}) =>
    this.request<Record<string, any>, ErrorResponse | HTTPValidationError>({
      path: `/api/admin/performance/health`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Get slow database queries above threshold.
   *
   * @tags Performance
   * @name GetSlowQueries
   * @summary Get Slow Queries
   * @request GET:/api/admin/performance/slow-queries
   * @secure
   */
  getSlowQueries = (
    query?: {
      /**
       * Threshold Ms
       * @default 100
       */
      threshold_ms?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<Record<string, any>, ErrorResponse | HTTPValidationError>({
      path: `/api/admin/performance/slow-queries`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Analyze common query patterns and performance.
   *
   * @tags Performance
   * @name AnalyzeQueryPatterns
   * @summary Analyze Query Patterns
   * @request GET:/api/admin/performance/query-patterns
   * @secure
   */
  analyzeQueryPatterns = (params: RequestParams = {}) =>
    this.request<Record<string, any>, ErrorResponse | HTTPValidationError>({
      path: `/api/admin/performance/query-patterns`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Get database connection pool health metrics.
   *
   * @tags Performance
   * @name GetConnectionHealth
   * @summary Get Connection Health
   * @request GET:/api/admin/performance/connection-health
   * @secure
   */
  getConnectionHealth = (params: RequestParams = {}) =>
    this.request<Record<string, any>, ErrorResponse | HTTPValidationError>({
      path: `/api/admin/performance/connection-health`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Get index usage effectiveness analysis.
   *
   * @tags Performance
   * @name GetIndexEffectiveness
   * @summary Get Index Effectiveness
   * @request GET:/api/admin/performance/index-effectiveness
   * @secure
   */
  getIndexEffectiveness = (params: RequestParams = {}) =>
    this.request<Record<string, any>, ErrorResponse | HTTPValidationError>({
      path: `/api/admin/performance/index-effectiveness`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Get current memory usage statistics.
   *
   * @tags Performance
   * @name GetMemoryUsage
   * @summary Get Memory Usage
   * @request GET:/api/admin/performance/memory-usage
   * @secure
   */
  getMemoryUsage = (params: RequestParams = {}) =>
    this.request<Record<string, any>, ErrorResponse | HTTPValidationError>({
      path: `/api/admin/performance/memory-usage`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Enable MongoDB profiler for performance monitoring.
   *
   * @tags Performance
   * @name EnableDatabaseProfiler
   * @summary Enable Database Profiler
   * @request POST:/api/admin/performance/profiler/enable
   * @secure
   */
  enableDatabaseProfiler = (
    query?: {
      /**
       * Level
       * @default 2
       */
      level?: number;
      /**
       * Slow Ms
       * @default 100
       */
      slow_ms?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<StatusResponse, ErrorResponse | HTTPValidationError>({
      path: `/api/admin/performance/profiler/enable`,
      method: "POST",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Disable MongoDB profiler.
   *
   * @tags Performance
   * @name DisableDatabaseProfiler
   * @summary Disable Database Profiler
   * @request POST:/api/admin/performance/profiler/disable
   * @secure
   */
  disableDatabaseProfiler = (params: RequestParams = {}) =>
    this.request<StatusResponse, ErrorResponse | HTTPValidationError>({
      path: `/api/admin/performance/profiler/disable`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Get AI-generated performance optimization recommendations.
   *
   * @tags Performance
   * @name GetPerformanceRecommendations
   * @summary Get Performance Recommendations
   * @request GET:/api/admin/performance/recommendations
   * @secure
   */
  getPerformanceRecommendations = (params: RequestParams = {}) =>
    this.request<Record<string, any>, ErrorResponse | HTTPValidationError>({
      path: `/api/admin/performance/recommendations`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Get SMTP configuration. Falls back to environment variables if no database config exists.
   *
   * @tags SMTP
   * @name GetSmtpConfigApiAdminSmtpConfigGet
   * @summary Get Smtp Config
   * @request GET:/api/admin/smtp/config
   * @secure
   */
  getSmtpConfigApiAdminSmtpConfigGet = (params: RequestParams = {}) =>
    this.request<SMTPConfigResponse, ErrorResponse | HTTPValidationError>({
      path: `/api/admin/smtp/config`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Save SMTP configuration.
   *
   * @tags SMTP
   * @name SaveSmtpConfigApiAdminSmtpConfigPost
   * @summary Save Smtp Config
   * @request POST:/api/admin/smtp/config
   * @secure
   */
  saveSmtpConfigApiAdminSmtpConfigPost = (
    data: SMTPConfigRequest,
    params: RequestParams = {},
  ) =>
    this.request<OperationResponse, ErrorResponse | HTTPValidationError>({
      path: `/api/admin/smtp/config`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Delete SMTP configuration (revert to environment settings).
   *
   * @tags SMTP
   * @name DeleteSmtpConfig
   * @summary Delete Smtp Config
   * @request DELETE:/api/admin/smtp/config
   * @secure
   */
  deleteSmtpConfig = (params: RequestParams = {}) =>
    this.request<OperationResponse, ErrorResponse | HTTPValidationError>({
      path: `/api/admin/smtp/config`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Debug SMTP connection step by step.
   *
   * @tags SMTP
   * @name DebugSmtpConnection
   * @summary Debug Smtp Connection
   * @request POST:/api/admin/smtp/debug
   * @secure
   */
  debugSmtpConnection = (params: RequestParams = {}) =>
    this.request<any, ErrorResponse | HTTPValidationError>({
      path: `/api/admin/smtp/debug`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Probe the configured email provider's transport (no message sent). Verifies that the resolved provider can connect/authenticate, so a misconfigured SMTP setup is surfaced here (admin diagnostics) rather than silently failing the next registration/reset email. Returns the active provider and per-provider verify status.
   *
   * @tags SMTP
   * @name EmailHealth
   * @summary Email Health
   * @request GET:/api/admin/smtp/health
   * @secure
   */
  emailHealth = (params: RequestParams = {}) =>
    this.request<any, ErrorResponse | HTTPValidationError>({
      path: `/api/admin/smtp/health`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Send a test email through the live outbound-email subsystem. Exercises the REAL delivery path (render -> enqueue -> RQ worker -> the configured provider) using the same DB+env config that drives verification/ reset mail -- so a passing test means production mail uses the same wiring. With the default mailhog provider the message is captured locally (view it at the MailHog UI); with gmail/smtp_generic it is delivered for real.
   *
   * @tags SMTP
   * @name TestSmtpConfig
   * @summary Test Smtp Config
   * @request POST:/api/admin/smtp/test
   * @secure
   */
  testSmtpConfig = (data: TestEmailRequest, params: RequestParams = {}) =>
    this.request<any, ErrorResponse | HTTPValidationError>({
      path: `/api/admin/smtp/test`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Consume a Postmark bounce/complaint webhook. Postmark posts ``RecordType`` in {"Bounce", "SpamComplaint", ...} with an ``Email`` field. Hard bounces (``Type`` == "HardBounce") and spam complaints suppress the address. Soft bounces are ignored (transient).
   *
   * @tags Email Webhooks
   * @name PostmarkWebhook
   * @summary Postmark Webhook
   * @request POST:/api/email/webhooks/postmark
   * @secure
   */
  postmarkWebhook = (
    query?: {
      /** Token */
      token?: string | null;
    },
    params: RequestParams = {},
  ) =>
    this.request<any, HTTPValidationError>({
      path: `/api/email/webhooks/postmark`,
      method: "POST",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Get available chat providers.
   *
   * @tags Chat Config
   * @name GetAvailableProvidersApiAdminChatConfigProvidersGet
   * @summary Get Available Providers
   * @request GET:/api/admin/chat-config/providers
   * @secure
   */
  getAvailableProvidersApiAdminChatConfigProvidersGet = (
    params: RequestParams = {},
  ) =>
    this.request<ChatProviderResponse[], ErrorResponse | HTTPValidationError>({
      path: `/api/admin/chat-config/providers`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Get currently active default chat configuration.
   *
   * @tags Chat Config
   * @name GetCurrentConfig
   * @summary Get Current Config
   * @request GET:/api/admin/chat-config/current
   * @secure
   */
  getCurrentConfig = (params: RequestParams = {}) =>
    this.request<ChatConfigResponse, ErrorResponse | HTTPValidationError>({
      path: `/api/admin/chat-config/current`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Get all chat configurations.
   *
   * @tags Chat Config
   * @name GetAllConfigs
   * @summary Get All Configs
   * @request GET:/api/admin/chat-config/all
   * @secure
   */
  getAllConfigs = (params: RequestParams = {}) =>
    this.request<ChatConfigResponse[], ErrorResponse | HTTPValidationError>({
      path: `/api/admin/chat-config/all`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Get all currently active chat configurations.
   *
   * @tags Chat Config
   * @name GetActiveConfigs
   * @summary Get Active Configs
   * @request GET:/api/admin/chat-config/active
   * @secure
   */
  getActiveConfigs = (params: RequestParams = {}) =>
    this.request<ChatConfigResponse[], ErrorResponse | HTTPValidationError>({
      path: `/api/admin/chat-config/active`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Test a chat configuration without saving it.
   *
   * @tags Chat Config
   * @name TestConfig
   * @summary Test Config
   * @request POST:/api/admin/chat-config/test
   * @secure
   */
  testConfig = (data: ChatConfigRequest, params: RequestParams = {}) =>
    this.request<ChatConfigTest, ErrorResponse | HTTPValidationError>({
      path: `/api/admin/chat-config/test`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Save and activate a chat configuration.
   *
   * @tags Chat Config
   * @name SaveConfig
   * @summary Save Config
   * @request POST:/api/admin/chat-config/save
   * @secure
   */
  saveConfig = (data: ChatConfigRequest, params: RequestParams = {}) =>
    this.request<StatusResponse, ErrorResponse | HTTPValidationError>({
      path: `/api/admin/chat-config/save`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Update an existing chat configuration.
   *
   * @tags Chat Config
   * @name UpdateConfig
   * @summary Update Config
   * @request PUT:/api/admin/chat-config/{config_id}
   * @secure
   */
  updateConfig = (
    configId: string,
    data: ChatConfigRequest,
    params: RequestParams = {},
  ) =>
    this.request<StatusResponse, ErrorResponse | HTTPValidationError>({
      path: `/api/admin/chat-config/${configId}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Delete a chat configuration.
   *
   * @tags Chat Config
   * @name DeleteConfig
   * @summary Delete Config
   * @request DELETE:/api/admin/chat-config/{config_id}
   * @secure
   */
  deleteConfig = (configId: string, params: RequestParams = {}) =>
    this.request<StatusResponse, ErrorResponse | HTTPValidationError>({
      path: `/api/admin/chat-config/${configId}`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Reset to environment variable configuration.
   *
   * @tags Chat Config
   * @name ResetToEnv
   * @summary Reset To Env
   * @request POST:/api/admin/chat-config/reset-to-env
   * @secure
   */
  resetToEnv = (params: RequestParams = {}) =>
    this.request<StatusResponse, ErrorResponse | HTTPValidationError>({
      path: `/api/admin/chat-config/reset-to-env`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Get currently active default chat configuration (optimized endpoint). PERFORMANCE OPTIMIZATION: - Single DB query optimized for single-tenant system
   *
   * @tags Chat Config
   * @name GetCurrentConfigOptimized
   * @summary Get Current Config Optimized
   * @request GET:/api/admin/chat-config/current-optimized
   * @secure
   */
  getCurrentConfigOptimized = (params: RequestParams = {}) =>
    this.request<ChatConfigResponse, ErrorResponse | HTTPValidationError>({
      path: `/api/admin/chat-config/current-optimized`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Get available chat configurations for user selection.
   *
   * @tags Chat Config
   * @name GetAvailableConfigs
   * @summary Get Available Configs
   * @request GET:/api/admin/chat-config/user/available
   * @secure
   */
  getAvailableConfigs = (params: RequestParams = {}) =>
    this.request<ChatConfigResponse[], ErrorResponse | HTTPValidationError>({
      path: `/api/admin/chat-config/user/available`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Get user's currently selected chat configuration.
   *
   * @tags Chat Config
   * @name GetUserCurrentConfig
   * @summary Get User Current Config
   * @request GET:/api/admin/chat-config/user/current
   * @secure
   */
  getUserCurrentConfig = (params: RequestParams = {}) =>
    this.request<ChatConfigResponse, ErrorResponse | HTTPValidationError>({
      path: `/api/admin/chat-config/user/current`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Save user's preferred chat model.
   *
   * @tags Chat Config
   * @name SaveUserPreference
   * @summary Save User Preference
   * @request POST:/api/admin/chat-config/user/preference
   * @secure
   */
  saveUserPreference = (data: UserChatPreference, params: RequestParams = {}) =>
    this.request<StatusResponse, ErrorResponse | HTTPValidationError>({
      path: `/api/admin/chat-config/user/preference`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Get available embedding providers with active status.
   *
   * @tags Embedding Config
   * @name GetAvailableProvidersApiAdminEmbeddingConfigProvidersGet
   * @summary Get Available Providers
   * @request GET:/api/admin/embedding-config/providers
   * @secure
   */
  getAvailableProvidersApiAdminEmbeddingConfigProvidersGet = (
    params: RequestParams = {},
  ) =>
    this.request<
      EmbeddingProviderResponse[],
      ErrorResponse | HTTPValidationError
    >({
      path: `/api/admin/embedding-config/providers`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Get currently active embedding configuration.
   *
   * @tags Embedding Config
   * @name GetCurrentConfigApiAdminEmbeddingConfigCurrentGet
   * @summary Get Current Config
   * @request GET:/api/admin/embedding-config/current
   * @secure
   */
  getCurrentConfigApiAdminEmbeddingConfigCurrentGet = (
    params: RequestParams = {},
  ) =>
    this.request<EmbeddingConfig, ErrorResponse | HTTPValidationError>({
      path: `/api/admin/embedding-config/current`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Get all embedding configurations.
   *
   * @tags Embedding Config
   * @name GetAllConfigsApiAdminEmbeddingConfigAllGet
   * @summary Get All Configs
   * @request GET:/api/admin/embedding-config/all
   * @secure
   */
  getAllConfigsApiAdminEmbeddingConfigAllGet = (params: RequestParams = {}) =>
    this.request<EmbeddingConfig[], ErrorResponse | HTTPValidationError>({
      path: `/api/admin/embedding-config/all`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Test an embedding configuration without saving it.
   *
   * @tags Embedding Config
   * @name TestConfigApiAdminEmbeddingConfigTestPost
   * @summary Test Config
   * @request POST:/api/admin/embedding-config/test
   * @secure
   */
  testConfigApiAdminEmbeddingConfigTestPost = (
    data: EmbeddingConfig,
    params: RequestParams = {},
  ) =>
    this.request<EmbeddingTestResponse, ErrorResponse | HTTPValidationError>({
      path: `/api/admin/embedding-config/test`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Save and activate an embedding configuration.
   *
   * @tags Embedding Config
   * @name SaveConfigApiAdminEmbeddingConfigSavePost
   * @summary Save Config
   * @request POST:/api/admin/embedding-config/save
   * @secure
   */
  saveConfigApiAdminEmbeddingConfigSavePost = (
    data: EmbeddingConfig,
    params: RequestParams = {},
  ) =>
    this.request<StatusResponse, ErrorResponse | HTTPValidationError>({
      path: `/api/admin/embedding-config/save`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Delete an embedding configuration.
   *
   * @tags Embedding Config
   * @name DeleteConfigApiAdminEmbeddingConfigConfigIdDelete
   * @summary Delete Config
   * @request DELETE:/api/admin/embedding-config/{config_id}
   * @secure
   */
  deleteConfigApiAdminEmbeddingConfigConfigIdDelete = (
    configId: string,
    params: RequestParams = {},
  ) =>
    this.request<StatusResponse, ErrorResponse | HTTPValidationError>({
      path: `/api/admin/embedding-config/${configId}`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Activate an existing embedding configuration.
   *
   * @tags Embedding Config
   * @name ActivateConfig
   * @summary Activate Config
   * @request POST:/api/admin/embedding-config/{config_id}/activate
   * @secure
   */
  activateConfig = (configId: string, params: RequestParams = {}) =>
    this.request<StatusResponse, ErrorResponse | HTTPValidationError>({
      path: `/api/admin/embedding-config/${configId}/activate`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Reset to environment variable configuration.
   *
   * @tags Embedding Config
   * @name ResetToEnvApiAdminEmbeddingConfigResetToEnvPost
   * @summary Reset To Env
   * @request POST:/api/admin/embedding-config/reset-to-env
   * @secure
   */
  resetToEnvApiAdminEmbeddingConfigResetToEnvPost = (
    params: RequestParams = {},
  ) =>
    this.request<StatusResponse, ErrorResponse | HTTPValidationError>({
      path: `/api/admin/embedding-config/reset-to-env`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Get available text extraction providers.
   *
   * @tags Text Extraction
   * @name GetAvailableProvidersApiAdminTextExtractionConfigProvidersGet
   * @summary Get Available Providers
   * @request GET:/api/admin/text-extraction-config/providers
   * @secure
   */
  getAvailableProvidersApiAdminTextExtractionConfigProvidersGet = (
    params: RequestParams = {},
  ) =>
    this.request<Record<string, any>[], ErrorResponse | HTTPValidationError>({
      path: `/api/admin/text-extraction-config/providers`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Get currently active text extraction configuration.
   *
   * @tags Text Extraction
   * @name GetCurrentConfigApiAdminTextExtractionConfigCurrentGet
   * @summary Get Current Config
   * @request GET:/api/admin/text-extraction-config/current
   * @secure
   */
  getCurrentConfigApiAdminTextExtractionConfigCurrentGet = (
    params: RequestParams = {},
  ) =>
    this.request<TextExtractionResponse, ErrorResponse | HTTPValidationError>({
      path: `/api/admin/text-extraction-config/current`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Get all text extraction configurations.
   *
   * @tags Text Extraction
   * @name GetAllConfigsApiAdminTextExtractionConfigAllGet
   * @summary Get All Configs
   * @request GET:/api/admin/text-extraction-config/all
   * @secure
   */
  getAllConfigsApiAdminTextExtractionConfigAllGet = (
    params: RequestParams = {},
  ) =>
    this.request<TextExtractionResponse[], ErrorResponse | HTTPValidationError>(
      {
        path: `/api/admin/text-extraction-config/all`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      },
    );
  /**
   * @description Save and activate a text extraction configuration.
   *
   * @tags Text Extraction
   * @name SaveConfigApiAdminTextExtractionConfigSavePost
   * @summary Save Config
   * @request POST:/api/admin/text-extraction-config/save
   * @secure
   */
  saveConfigApiAdminTextExtractionConfigSavePost = (
    data: TextExtractionRequest,
    params: RequestParams = {},
  ) =>
    this.request<StatusResponse, ErrorResponse | HTTPValidationError>({
      path: `/api/admin/text-extraction-config/save`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description List all MCP server configs. Never includes any client secret.
   *
   * @tags MCP Server Configs
   * @name ListMcpServerConfigs
   * @summary List Mcp Server Configs
   * @request GET:/api/admin/mcp-server-configs
   * @secure
   */
  listMcpServerConfigs = (params: RequestParams = {}) =>
    this.request<
      McpServerConfigResponse[],
      ErrorResponse | HTTPValidationError
    >({
      path: `/api/admin/mcp-server-configs`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Register a new MCP server. Validates the server URL (SSRF, S4).
   *
   * @tags MCP Server Configs
   * @name CreateMcpServerConfig
   * @summary Create Mcp Server Config
   * @request POST:/api/admin/mcp-server-configs
   * @secure
   */
  createMcpServerConfig = (
    data: McpServerConfigCreate,
    params: RequestParams = {},
  ) =>
    this.request<McpServerConfigResponse, ErrorResponse | HTTPValidationError>({
      path: `/api/admin/mcp-server-configs`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Get one MCP server config by key. Never includes any client secret.
   *
   * @tags MCP Server Configs
   * @name GetMcpServerConfig
   * @summary Get Mcp Server Config
   * @request GET:/api/admin/mcp-server-configs/{server_key}
   * @secure
   */
  getMcpServerConfig = (serverKey: string, params: RequestParams = {}) =>
    this.request<McpServerConfigResponse, ErrorResponse | HTTPValidationError>({
      path: `/api/admin/mcp-server-configs/${serverKey}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Full-replace update of an existing MCP server. Bumps ``config_version``.
   *
   * @tags MCP Server Configs
   * @name UpdateMcpServerConfig
   * @summary Update Mcp Server Config
   * @request PUT:/api/admin/mcp-server-configs/{server_key}
   * @secure
   */
  updateMcpServerConfig = (
    serverKey: string,
    data: McpServerConfigUpdate,
    params: RequestParams = {},
  ) =>
    this.request<McpServerConfigResponse, ErrorResponse | HTTPValidationError>({
      path: `/api/admin/mcp-server-configs/${serverKey}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Delete an MCP server config.
   *
   * @tags MCP Server Configs
   * @name DeleteMcpServerConfig
   * @summary Delete Mcp Server Config
   * @request DELETE:/api/admin/mcp-server-configs/{server_key}
   * @secure
   */
  deleteMcpServerConfig = (serverKey: string, params: RequestParams = {}) =>
    this.request<void, ErrorResponse | HTTPValidationError>({
      path: `/api/admin/mcp-server-configs/${serverKey}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * @description Discover the server's current tool set and pin it (S6). Connects to the server unauthenticated (no per-user OAuth token is available to an admin action) via ``services.mcp.oauth_flow.discover_server_tools`` -- the same SSRF-pinned transport the per-user toolset pool uses -- hashes the discovered tools via the exact same ``compute_tools_hash`` the pool verifies against at connect time, and persists the hash plus the discovered tool names as the new pinned allowlist. Bumps ``config_version``, so every pooled toolset for this server is invalidated and re-verified on next use. A discovery failure (network error, SSRF-pinned host rejection, or a malformed MCP handshake) never leaks transport detail to the client -- only the exception type is logged (see ``discover_server_tools``). A discovered tool set that exceeds the same tool-count/total-schema-bytes caps the pool enforces at connect time (``enforce_tool_caps``) is likewise rejected here, opaquely -- pinning a tool set the pool would then always refuse to load would leave the server permanently unusable.
   *
   * @tags MCP Server Configs
   * @name PinMcpServerConfig
   * @summary Pin Mcp Server Config
   * @request POST:/api/admin/mcp-server-configs/{server_key}/pin
   * @secure
   */
  pinMcpServerConfig = (serverKey: string, params: RequestParams = {}) =>
    this.request<McpServerConfigResponse, ErrorResponse | HTTPValidationError>({
      path: `/api/admin/mcp-server-configs/${serverKey}/pin`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description List MCP tool-call audit entries (newest first). Admin-only. Returns only the stored audit fields -- argument shape and HMAC fingerprint, never raw arguments or tool results.
   *
   * @tags MCP Audit
   * @name ListMcpToolAuditEntries
   * @summary List Mcp Tool Audit Entries
   * @request GET:/api/admin/mcp-audit
   * @secure
   */
  listMcpToolAuditEntries = (
    query?: {
      /**
       * User Id
       * Filter by acting user id
       */
      user_id?: string | null;
      /**
       * Mcp Server Id
       * Filter by MCP server id
       */
      mcp_server_id?: string | null;
      /**
       * Status
       * Filter by call status
       */
      status?:
        | "started"
        | "succeeded"
        | "failed"
        | "aborted"
        | "refused"
        | "unknown"
        | null;
      /**
       * Started After
       * Only entries started at or after this time (UTC)
       */
      started_after?: string | null;
      /**
       * Started Before
       * Only entries started at or before this time (UTC)
       */
      started_before?: string | null;
      /**
       * Limit
       * Maximum number of entries
       * @min 1
       * @max 200
       * @default 100
       */
      limit?: number;
      /**
       * Skip
       * Number of entries to skip
       * @min 0
       * @default 0
       */
      skip?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<McpAuditListResponse, ErrorResponse | HTTPValidationError>({
      path: `/api/admin/mcp-audit`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Begin the per-user OAuth flow for one admin-configured MCP server. Returns ``{"authorize_url": "..."}`` for the caller to redirect to. An unknown, disabled, or wrong-``auth_mode`` server all collapse to the same opaque 404 -- distinguishing them (as a prior version of this route did) would let any authenticated user enumerate configured ``server_key``s and probe their ``auth_mode``/``enabled`` state.
   *
   * @tags MCP OAuth
   * @name StartLinkApiMcpServersServerKeyLinkStartPost
   * @summary Start Link
   * @request POST:/api/mcp-servers/{server_key}/link/start
   * @secure
   */
  startLinkApiMcpServersServerKeyLinkStartPost = (
    serverKey: string,
    params: RequestParams = {},
  ) =>
    this.request<Record<string, string>, ErrorResponse | HTTPValidationError>({
      path: `/api/mcp-servers/${serverKey}/link/start`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Handle the OAuth redirect from the pinned authorization server. Public endpoint (no ``CurrentUser``): the browser is redirected here by the upstream authorization server, exactly like ``routers.identity_link.link_callback``. The target user is resolved from the one-time state record inside ``OAuthFlowService.handle_callback``, not from any live session on this request. Rate-limited per (client IP, ``provider_key``) before anything else runs -- FastAPI resolves all of a route's dependencies before the route body, so a caller who has exhausted the window gets a 429 without the state token ever being looked up. State is then looked up and atomically consumed inside ``handle_callback`` before any further processing.
   *
   * @tags MCP OAuth
   * @name LinkCallbackApiMcpServersProviderKeyLinkCallbackGet
   * @summary Link Callback
   * @request GET:/api/mcp-servers/{provider_key}/link/callback
   * @secure
   */
  linkCallbackApiMcpServersProviderKeyLinkCallbackGet = (
    providerKey: string,
    query?: {
      /** Code */
      code?: string | null;
      /** State */
      state?: string | null;
      /** Iss */
      iss?: string | null;
      /** Error */
      error?: string | null;
      /** Error Description */
      error_description?: string | null;
    },
    params: RequestParams = {},
  ) =>
    this.request<any, ErrorResponse | HTTPValidationError>({
      path: `/api/mcp-servers/${providerKey}/link/callback`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Unlink the current user's stored OAuth credential for one MCP server.
   *
   * @tags MCP OAuth
   * @name UnlinkMcpServer
   * @summary Unlink Mcp Server
   * @request DELETE:/api/mcp-servers/{server_key}/link
   * @secure
   */
  unlinkMcpServer = (serverKey: string, params: RequestParams = {}) =>
    this.request<Record<string, string>, ErrorResponse | HTTPValidationError>({
      path: `/api/mcp-servers/${serverKey}/link`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Validate a public shared folder link and return folder information.
   *
   * @tags Shared Folders
   * @name ValidateSharedFolder
   * @summary Validate Shared Folder
   * @request POST:/api/shared-folders/validate
   * @secure
   */
  validateSharedFolder = (
    data: SharedFolderValidateRequest,
    params: RequestParams = {},
  ) =>
    this.request<Record<string, any>, ErrorResponse | HTTPValidationError>({
      path: `/api/shared-folders/validate`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Import files from a shared folder into the document system.
   *
   * @tags Shared Folders
   * @name ImportSharedFolder
   * @summary Import Shared Folder
   * @request POST:/api/shared-folders/import
   * @secure
   */
  importSharedFolder = (
    data: SharedFolderImportRequest,
    params: RequestParams = {},
  ) =>
    this.request<Record<string, any>, ErrorResponse | HTTPValidationError>({
      path: `/api/shared-folders/import`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Validate a shared folder URL and discover available files.
   *
   * @tags Folder Syncs
   * @name ValidateFolderUrl
   * @summary Validate Folder Url
   * @request POST:/api/folder-syncs/validate-url
   * @secure
   */
  validateFolderUrl = (
    data: ValidateFolderUrlRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      ValidateFolderUrlResponse,
      ErrorResponse | HTTPValidationError
    >({
      path: `/api/folder-syncs/validate-url`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description List all folder syncs for the current user.
   *
   * @tags Folder Syncs
   * @name ListFolderSyncs
   * @summary List Folder Syncs
   * @request GET:/api/folder-syncs/
   * @secure
   */
  listFolderSyncs = (params: RequestParams = {}) =>
    this.request<FolderSync[], ErrorResponse | HTTPValidationError>({
      path: `/api/folder-syncs/`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Create a new folder sync connection.
   *
   * @tags Folder Syncs
   * @name CreateFolderSync
   * @summary Create Folder Sync
   * @request POST:/api/folder-syncs/
   * @secure
   */
  createFolderSync = (data: FolderSyncCreate, params: RequestParams = {}) =>
    this.request<FolderSync, ErrorResponse | HTTPValidationError>({
      path: `/api/folder-syncs/`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Get a specific folder sync by ID.
   *
   * @tags Folder Syncs
   * @name GetFolderSync
   * @summary Get Folder Sync
   * @request GET:/api/folder-syncs/{sync_id}
   * @secure
   */
  getFolderSync = (syncId: string, params: RequestParams = {}) =>
    this.request<FolderSync, ErrorResponse | HTTPValidationError>({
      path: `/api/folder-syncs/${syncId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Update a folder sync connection.
   *
   * @tags Folder Syncs
   * @name UpdateFolderSync
   * @summary Update Folder Sync
   * @request PUT:/api/folder-syncs/{sync_id}
   * @secure
   */
  updateFolderSync = (
    syncId: string,
    data: FolderSyncUpdate,
    params: RequestParams = {},
  ) =>
    this.request<FolderSync, ErrorResponse | HTTPValidationError>({
      path: `/api/folder-syncs/${syncId}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Delete a folder sync connection.
   *
   * @tags Folder Syncs
   * @name DeleteFolderSync
   * @summary Delete Folder Sync
   * @request DELETE:/api/folder-syncs/{sync_id}
   * @secure
   */
  deleteFolderSync = (syncId: string, params: RequestParams = {}) =>
    this.request<any, ErrorResponse | HTTPValidationError>({
      path: `/api/folder-syncs/${syncId}`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Trigger manual sync for a folder sync connection.
   *
   * @tags Folder Syncs
   * @name TriggerFolderSync
   * @summary Trigger Folder Sync
   * @request POST:/api/folder-syncs/{sync_id}/sync
   * @secure
   */
  triggerFolderSync = (syncId: string, params: RequestParams = {}) =>
    this.request<any, ErrorResponse | HTTPValidationError>({
      path: `/api/folder-syncs/${syncId}/sync`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description List all system connections (admin only). Returns all rows in the ``connections`` collection, including system connections created automatically by the local_upload provider.
   *
   * @tags Connections
   * @name ListConnections
   * @summary List Connections
   * @request GET:/api/connections
   * @secure
   */
  listConnections = (params: RequestParams = {}) =>
    this.request<Record<string, any>[], ErrorResponse | HTTPValidationError>({
      path: `/api/connections`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Get a specific system connection by ID (admin only).
   *
   * @tags Connections
   * @name GetConnection
   * @summary Get Connection
   * @request GET:/api/connections/{connection_id}
   * @secure
   */
  getConnection = (connectionId: string, params: RequestParams = {}) =>
    this.request<Record<string, any>, ErrorResponse | HTTPValidationError>({
      path: `/api/connections/${connectionId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Update a system connection. Returns 403 if the connection is a system-managed local_upload connection (``is_system=True AND provider_key="local_upload"``).
   *
   * @tags Connections
   * @name UpdateConnection
   * @summary Update Connection
   * @request PUT:/api/connections/{connection_id}
   * @secure
   */
  updateConnection = (connectionId: string, params: RequestParams = {}) =>
    this.request<any, ErrorResponse | HTTPValidationError>({
      path: `/api/connections/${connectionId}`,
      method: "PUT",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Partially update a system connection. Returns 403 if the connection is a system-managed local_upload connection.
   *
   * @tags Connections
   * @name PatchConnection
   * @summary Patch Connection
   * @request PATCH:/api/connections/{connection_id}
   * @secure
   */
  patchConnection = (connectionId: string, params: RequestParams = {}) =>
    this.request<any, ErrorResponse | HTTPValidationError>({
      path: `/api/connections/${connectionId}`,
      method: "PATCH",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Delete a system connection. Returns 403 if the connection is a system-managed local_upload connection (``is_system=True AND provider_key="local_upload"``).
   *
   * @tags Connections
   * @name DeleteConnection
   * @summary Delete Connection
   * @request DELETE:/api/connections/{connection_id}
   * @secure
   */
  deleteConnection = (connectionId: string, params: RequestParams = {}) =>
    this.request<void, ErrorResponse | HTTPValidationError>({
      path: `/api/connections/${connectionId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
}
